(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("app-bridge", [], factory);
	else if(typeof exports === 'object')
		exports["app-bridge"] = factory();
	else
		root["app-bridge"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		(function (module) {
/******/ 		  if (module.exports
/******/ 		    && !module.exports.__esModule
/******/ 		    && module.exports.default === undefined
/******/ 		  ) {
/******/ 		    if (module.exports.headers
/******/ 		      && module.exports.headers.common
/******/ 		      && module.exports.headers.common.Accept
/******/ 		      && module.exports.adapter
/******/ 		      && module.exports.transformRequest
/******/ 		      && module.exports.transformResponse
/******/ 		    ) {
/******/ 		      return;
/******/ 		    }
/******/ 		    module.exports.default = module.exports;
/******/ 		  }
/******/ 		})(module);
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 68);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(28));
__export(__webpack_require__(11));


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Types
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Group;
(function (Group) {
    Group["Button"] = "Button";
    Group["ButtonGroup"] = "ButtonGroup";
    Group["Cart"] = "Cart";
    Group["Error"] = "Error";
    Group["Flash"] = "Flash";
    Group["Loading"] = "Loading";
    Group["Modal"] = "Modal";
    Group["Navigation"] = "Navigation";
    Group["Print"] = "Print";
    Group["TitleBar"] = "TitleBar";
    Group["ResourcePicker"] = "Resource_Picker";
})(Group = exports.Group || (exports.Group = {}));
var ComponentType;
(function (ComponentType) {
    ComponentType["Button"] = "Button";
    ComponentType["ButtonGroup"] = "ButtonGroup";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Error_1 = __webpack_require__(0);
var collection_1 = __webpack_require__(9);
var constants_1 = __webpack_require__(12);
var merge_1 = __importDefault(__webpack_require__(29));
var types_1 = __webpack_require__(1);
var uuid_1 = __importDefault(__webpack_require__(30));
var info = __webpack_require__(31);
var SEPARATOR = '::';
function actionWrapper(action) {
    return __assign({}, action, { version: getVersion() });
}
exports.actionWrapper = actionWrapper;
function getVersion() {
    return info.version;
}
exports.getVersion = getVersion;
function getEventNameSpace(group, eventName, component) {
    var eventNameSpace = group.toUpperCase();
    if (component) {
        var subgroups_1 = component.subgroups, type = component.type;
        if (subgroups_1 && subgroups_1.length > 0) {
            eventNameSpace += eventNameSpace.length > 0 ? SEPARATOR : '';
            subgroups_1.forEach(function (subgroup, index) {
                eventNameSpace += "" + subgroup.toUpperCase() + (index < subgroups_1.length - 1 ? SEPARATOR : '');
            });
        }
        if (type !== group && type) {
            eventNameSpace += "" + (eventNameSpace.length > 0 ? SEPARATOR : '') + type.toUpperCase();
        }
    }
    if (eventNameSpace) {
        eventNameSpace += "" + (eventNameSpace.length > 0 ? SEPARATOR : '') + eventName.toUpperCase();
    }
    return "" + constants_1.PREFIX + SEPARATOR + eventNameSpace;
}
exports.getEventNameSpace = getEventNameSpace;
function isValidOptionalNumber(value) {
    return value === null || value === undefined || typeof value === 'number';
}
exports.isValidOptionalNumber = isValidOptionalNumber;
function isValidOptionalString(value) {
    return value === null || value === undefined || typeof value === 'string';
}
exports.isValidOptionalString = isValidOptionalString;
var ActionSet = /** @class */ (function () {
    function ActionSet(app, type, group, id) {
        this.subgroups = [];
        this.subscriptions = [];
        if (!app) {
            Error_1.throwError(Error_1.ActionType.INVALID_OPTIONS, 'Missing required `app`');
        }
        this.id = id || uuid_1.default();
        this.app = app;
        this.type = type;
        this.group = group;
        this.defaultGroup = group;
    }
    Object.defineProperty(ActionSet.prototype, "component", {
        get: function () {
            return {
                id: this.id,
                subgroups: this.subgroups,
                type: this.type,
            };
        },
        enumerable: true,
        configurable: true
    });
    ActionSet.prototype.updateSubscription = function (subscriptionToRemove, group, subgroups) {
        var eventType = subscriptionToRemove.eventType, callback = subscriptionToRemove.callback, component = subscriptionToRemove.component;
        var currentIndex;
        currentIndex = this.subscriptions.findIndex(function (subscription) { return subscription === subscriptionToRemove; });
        if (currentIndex >= 0) {
            this.subscriptions[currentIndex].unsubscribe();
        }
        else {
            currentIndex = undefined;
        }
        this.group = group;
        this.subgroups = subgroups;
        Object.assign(component, { subgroups: this.subgroups });
        return this.subscribe(eventType, callback, component, currentIndex);
    };
    ActionSet.prototype.error = function (callback) {
        var _this = this;
        var subscriptionIndices = [];
        forEachInEnum(Error_1.Action, function (eventNameSpace) {
            // Keep track of subscription index so we can call unsubscribe later
            // This ensure it will continue to work even when the subscription has been updated
            subscriptionIndices.push(_this.subscriptions.length);
            _this.subscribe(eventNameSpace, callback);
        });
        return function () {
            var subscriptionsToRemove = subscriptionIndices.map(function (index) { return _this.subscriptions[index]; });
            subscriptionsToRemove.forEach(function (toRemove) {
                collection_1.removeFromCollection(_this.subscriptions, toRemove, function (removed) {
                    removed.unsubscribe();
                });
            });
        };
    };
    ActionSet.prototype.subscribe = function (eventName, callback, component, currentIndex) {
        var _this = this;
        var eventComponent = component || this.component;
        var eventType = eventName.toUpperCase();
        var boundedCallback = typeof currentIndex === 'number' ? callback : callback.bind(this);
        var eventNameSpace;
        if (Error_1.isErrorEventName(eventName)) {
            eventNameSpace = getEventNameSpace(types_1.Group.Error, eventName, __assign({}, eventComponent, { type: '' }));
        }
        else {
            eventNameSpace = getEventNameSpace(this.group, eventName, eventComponent);
        }
        var unsubscribe = this.app.subscribe(eventNameSpace, boundedCallback, component ? component.id : this.id);
        var subscription = {
            eventType: eventType,
            unsubscribe: unsubscribe,
            callback: boundedCallback,
            component: eventComponent,
            updateSubscribe: function (group, subgroups) {
                return _this.updateSubscription.call(_this, subscription, group, subgroups);
            },
        };
        if (typeof currentIndex === 'number' &&
            currentIndex >= 0 &&
            currentIndex < this.subscriptions.length) {
            this.subscriptions[currentIndex] = subscription;
        }
        else {
            this.subscriptions.push(subscription);
        }
        return unsubscribe;
    };
    ActionSet.prototype.unsubscribe = function (resetOnly) {
        if (resetOnly === void 0) { resetOnly = false; }
        unsubscribeActions(this.subscriptions, this.defaultGroup, resetOnly);
        return this;
    };
    return ActionSet;
}());
exports.ActionSet = ActionSet;
var ActionSetWithChildren = /** @class */ (function (_super) {
    __extends(ActionSetWithChildren, _super);
    function ActionSetWithChildren() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.children = [];
        return _this;
    }
    ActionSetWithChildren.prototype.unsubscribe = function (unsubscribeChildren, resetParentOnly) {
        if (unsubscribeChildren === void 0) { unsubscribeChildren = true; }
        if (resetParentOnly === void 0) { resetParentOnly = false; }
        unsubscribeActions(this.subscriptions, this.defaultGroup, resetParentOnly);
        this.children.forEach(function (child) {
            if (ActionSetWithChildren.prototype.isPrototypeOf(child)) {
                child.unsubscribe(unsubscribeChildren, unsubscribeChildren ? false : true);
            }
            else {
                child.unsubscribe(unsubscribeChildren ? false : true);
            }
        });
        return this;
    };
    ActionSetWithChildren.prototype.getChild = function (id) {
        var childIndex = this.children.findIndex(function (child) { return child.id === id; });
        return childIndex >= 0 ? this.children[childIndex] : undefined;
    };
    ActionSetWithChildren.prototype.getChildIndex = function (id) {
        return this.children.findIndex(function (child) { return child.id === id; });
    };
    ActionSetWithChildren.prototype.getChildSubscriptions = function (id, eventType) {
        return this.subscriptions.filter(function (sub) { return sub.component.id === id && (!eventType || eventType === sub.eventType); });
    };
    ActionSetWithChildren.prototype.addChild = function (child, group, subgroups) {
        var _this = this;
        var subscriptions = child.subscriptions;
        var existingChild = this.getChild(child.id);
        // Add child if it doesn't already exist
        if (!existingChild) {
            this.children.push(child);
        }
        if (!subscriptions || (group === child.group && subgroups === child.subgroups)) {
            return this;
        }
        subscriptions.forEach(function (subscription) {
            var updateSubscribe = subscription.updateSubscribe;
            updateSubscribe(group, subgroups);
        });
        // Update child's group and subgroups
        Object.assign(child, { group: group, subgroups: subgroups });
        // Update child's children subscriptions
        if (ActionSetWithChildren.prototype.isPrototypeOf(child)) {
            child.children.forEach(function (c) { return _this.addChild(c, group, subgroups); });
        }
        return this;
    };
    ActionSetWithChildren.prototype.removeChild = function (id) {
        var _this = this;
        collection_1.removeFromCollection(this.children, this.getChild(id), function () {
            var toBeRemoved = _this.subscriptions.filter(function (subs) { return subs.component.id === id; });
            toBeRemoved.forEach(function (toRemove) {
                collection_1.removeFromCollection(_this.subscriptions, toRemove, function (removed) {
                    removed.unsubscribe();
                });
            });
        });
        return this;
    };
    ActionSetWithChildren.prototype.subscribeToChild = function (child, eventName, callback) {
        var _this = this;
        var boundedCallback = callback.bind(this);
        if (eventName instanceof Array) {
            eventName.forEach(function (e) { return _this.subscribeToChild(child, e, callback); });
            return this;
        }
        if (typeof eventName !== 'string') {
            return this;
        }
        var eventType = eventName.toUpperCase();
        var currentSubscriptions = this.getChildSubscriptions(child.id, eventType);
        if (currentSubscriptions.length > 0) {
            // Subscription is already there, simply update it
            currentSubscriptions.forEach(function (subs) { return subs.updateSubscribe(_this.group, child.subgroups); });
        }
        else {
            var childComponent = {
                id: child.id,
                subgroups: child.subgroups,
                type: child.type,
            };
            this.subscribe(eventType, boundedCallback, childComponent);
        }
        return this;
    };
    ActionSetWithChildren.prototype.getUpdatedChildActions = function (newActions, currentActions) {
        if (newActions.length === 0) {
            while (currentActions.length > 0) {
                var action = currentActions.pop();
                if (!action) {
                    break;
                }
                this.removeChild(action.id);
            }
            return undefined;
        }
        // Only allow unique actions
        var uniqueActions = newActions.filter(function (action, index, actionsArr) { return index === actionsArr.indexOf(action); });
        var newActionIds = uniqueActions.map(function (action) { return action.id; });
        // Remove unused actions
        var unusedActions = currentActions.filter(function (action) {
            return newActionIds.indexOf(action.id) < 0;
        });
        while (unusedActions.length > 0) {
            var action = unusedActions.pop();
            if (!action) {
                break;
            }
            this.removeChild(action.id);
        }
        return uniqueActions;
    };
    return ActionSetWithChildren;
}(ActionSet));
exports.ActionSetWithChildren = ActionSetWithChildren;
function unsubscribeActions(subscriptions, defaultGroup, reassign) {
    if (reassign === void 0) { reassign = false; }
    subscriptions.forEach(function (subscription) {
        if (reassign) {
            var updateSubscribe = subscription.updateSubscribe;
            // TODO: Support cases where we don't wipe out group and subgroups to defaults
            updateSubscribe(defaultGroup, []);
        }
        else {
            var unsubscribe = subscription.unsubscribe;
            unsubscribe();
        }
    });
    if (!reassign) {
        subscriptions.length = 0;
    }
}
function sanitizeProps(obj, keys) {
    var newObj = {};
    keys.forEach(function (key) {
        if (obj.hasOwnProperty(key)) {
            newObj[key] = obj[key];
        }
    });
    return newObj;
}
exports.sanitizeProps = sanitizeProps;
function updateActionFromPayload(action, newProps) {
    var id = action.id;
    if (id === newProps.id) {
        // Merge new properties
        Object.assign(action, getMergedProps(action, newProps));
        return true;
    }
    return false;
}
exports.updateActionFromPayload = updateActionFromPayload;
function getMergedProps(props, newProps) {
    var merged = merge_1.default(props, newProps);
    if (!merged) {
        // tslint:disable-next-line:prefer-object-spread
        var cloned = Object.assign(props, newProps);
        return cloned;
    }
    return merged;
}
exports.getMergedProps = getMergedProps;
function forEachInEnum(types, callback) {
    Object.keys(types).forEach(function (key) {
        callback(types[key]);
    });
}
exports.forEachInEnum = forEachInEnum;
function findMatchInEnum(types, lookup) {
    var match = Object.keys(types).find(function (key) {
        return lookup === types[key];
    });
    return match ? types[match] : undefined;
}
exports.findMatchInEnum = findMatchInEnum;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(32));
__export(__webpack_require__(13));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(33));
__export(__webpack_require__(14));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __webpack_require__(3);
function getSingleButton(action, button, subgroups, updateCb) {
    action.addChild(button, action.group, subgroups);
    var id = button.id, label = button.label, primary = button.primary, disabled = button.disabled;
    var singleButton = {
        disabled: disabled,
        id: id,
        label: label,
        primary: primary,
    };
    action.subscribeToChild(button, Button_1.Action.UPDATE, updateCb);
    return singleButton;
}
exports.getSingleButton = getSingleButton;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isValidRelativePath(path) {
    return typeof path === 'string' && (path === '' || path.charAt(0) === '/');
}
exports.isValidRelativePath = isValidRelativePath;
function isValidAbsolutePath(path) {
    return typeof path === 'string' && path.match('^https?://');
}
exports.isValidAbsolutePath = isValidAbsolutePath;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module History
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ActionType;
(function (ActionType) {
    ActionType["PUSH"] = "APP::NAVIGATION::HISTORY::PUSH";
    ActionType["REPLACE"] = "APP::NAVIGATION::HISTORY::REPLACE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var Action;
(function (Action) {
    Action["PUSH"] = "PUSH";
    Action["REPLACE"] = "REPLACE";
})(Action = exports.Action || (exports.Action = {}));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Action;
(function (Action) {
    Action["ADMIN_PATH"] = "ADMIN::PATH";
    Action["ADMIN_SECTION"] = "ADMIN::SECTION";
    Action["REMOTE"] = "REMOTE";
    Action["APP"] = "APP";
})(Action = exports.Action || (exports.Action = {}));
var ActionType;
(function (ActionType) {
    ActionType["ADMIN_SECTION"] = "APP::NAVIGATION::REDIRECT::ADMIN::SECTION";
    ActionType["ADMIN_PATH"] = "APP::NAVIGATION::REDIRECT::ADMIN::PATH";
    ActionType["REMOTE"] = "APP::NAVIGATION::REDIRECT::REMOTE";
    ActionType["APP"] = "APP::NAVIGATION::REDIRECT::APP";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["Product"] = "products";
    ResourceType["Collection"] = "collections";
    ResourceType["Order"] = "orders";
    ResourceType["Customer"] = "customers";
    ResourceType["Discount"] = "discounts";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module util
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Add an item to a collection, return a function that can then be used to
 * remove the item from the collection. Optionally accepting a callback that is
 * invoked when the item is removed from the collection.
 */
function addAndRemoveFromCollection(collection, item, then) {
    collection.push(item);
    return function () {
        return removeFromCollection(collection, item, then);
    };
}
exports.addAndRemoveFromCollection = addAndRemoveFromCollection;
/**
 * Remove the item from the collection. Optionally accepting a callback that is
 * invoked when the item is removed from the collection.
 */
function removeFromCollection(collection, item, then) {
    var idx = collection.findIndex(function (i) { return i === item; });
    if (idx >= 0) {
        collection.splice(idx, 1);
        if (then) {
            then(item);
        }
        return true;
    }
    return false;
}
exports.removeFromCollection = removeFromCollection;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Actions = __importStar(__webpack_require__(24));
var Error_1 = __webpack_require__(0);
var constants_1 = __webpack_require__(12);
var MANDATORY_ACTION_PROPS = ['group', 'type', 'version'];
function isAppBridgeAction(action) {
    return (action instanceof Object &&
        action.hasOwnProperty('type') &&
        action.type.toString().startsWith(constants_1.PREFIX));
}
exports.isAppBridgeAction = isAppBridgeAction;
function isFromApp(action) {
    if (typeof action !== 'object' || typeof action.source !== 'object') {
        return false;
    }
    return typeof action.source.apiKey === 'string';
}
exports.isFromApp = isFromApp;
function isAppMessage(event) {
    if (typeof event !== 'object' || !event.data || typeof event.data !== 'object') {
        return false;
    }
    var data = event.data;
    return data.hasOwnProperty('type') && (data.type === 'getState' || data.type === 'dispatch');
}
exports.isAppMessage = isAppMessage;
function validatedActionPayload(action, origin) {
    switch (action.group) {
        case Actions.Group.Button:
            return Actions.Button.validationError(action) || action;
        case Actions.Group.ButtonGroup:
            return Actions.ButtonGroup.validationError(action) || action;
        case Actions.Group.Cart:
            return Actions.Cart.validationError(action) || action;
        case Actions.Group.Flash:
            return Actions.Flash.validationError(action) || action;
        case Actions.Group.Modal:
            return Actions.Modal.validationError(action, origin) || action;
        case Actions.Group.TitleBar:
            return Actions.TitleBar.validationError(action) || action;
        case Actions.Group.Navigation:
            return Actions.Navigation.validationError(action) || action;
        case Actions.Group.Error:
            return action;
        case Actions.Group.Print:
            return Actions.Print.validationError(action) || action;
        case Actions.Group.Loading:
            return Actions.Loading.validationError(action) || action;
        case Actions.Group.ResourcePicker:
            return Actions.ResourcePicker.validationError(action) || action;
        default:
            return Error_1.invalidAction(action, 'Unknown or unsupported action group');
    }
}
exports.validatedActionPayload = validatedActionPayload;
function validatedAction(action, origin) {
    if (!isAppBridgeAction(action)) {
        return action;
    }
    for (var _i = 0, MANDATORY_ACTION_PROPS_1 = MANDATORY_ACTION_PROPS; _i < MANDATORY_ACTION_PROPS_1.length; _i++) {
        var prop = MANDATORY_ACTION_PROPS_1[_i];
        if (!action.hasOwnProperty(prop) || typeof action[prop] !== 'string') {
            return Error_1.invalidAction(action, "Missing or invalid " + prop);
        }
    }
    return validatedActionPayload(action, origin);
}
exports.validatedAction = validatedAction;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Action;
(function (Action) {
    Action["INVALID_ACTION"] = "INVALID_ACTION";
    Action["INVALID_ACTION_TYPE"] = "INVALID_ACTION_TYPE";
    Action["INVALID_OPTIONS"] = "INVALID_OPTIONS";
    Action["INVALID_PAYLOAD"] = "INVALID_PAYLOAD";
    Action["UNEXPECTED_ACTION"] = "UNEXPECTED_ACTION";
    Action["PERSISTENCE"] = "PERSISTENCE";
    Action["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    Action["NETWORK"] = "NETWORK";
    Action["PERMISSION"] = "PERMISSION";
})(Action = exports.Action || (exports.Action = {}));
var ActionType;
(function (ActionType) {
    ActionType["INVALID_ACTION"] = "APP::ERROR::INVALID_ACTION";
    ActionType["INVALID_ACTION_TYPE"] = "APP::ERROR::INVALID_ACTION_TYPE";
    ActionType["INVALID_PAYLOAD"] = "APP::ERROR::INVALID_PAYLOAD";
    ActionType["INVALID_OPTIONS"] = "APP::ERROR::INVALID_OPTIONS";
    ActionType["UNEXPECTED_ACTION"] = "APP::ERROR::UNEXPECTED_ACTION";
    ActionType["PERSISTENCE"] = "APP::ERROR::PERSISTENCE";
    ActionType["UNSUPPORTED_OPERATION"] = "APP::ERROR::UNSUPPORTED_OPERATION";
    ActionType["NETWORK"] = "APP::ERROR::NETWORK";
    ActionType["PERMISSION"] = "APP::ERROR::PERMISSION";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var AppActionType;
(function (AppActionType) {
    AppActionType["INVALID_CONFIG"] = "APP::ERROR:INVALID_CONFIG";
    AppActionType["MISSING_CONFIG"] = "APP::APP_ERROR::MISSING_CONFIG";
    AppActionType["MISSING_APP_BRIDGE_MIDDLEWARE"] = "APP::APP_ERROR::MISSING_APP_BRIDGE_MIDDLEWARE";
})(AppActionType = exports.AppActionType || (exports.AppActionType = {}));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFIX = 'APP';


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Button
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Action;
(function (Action) {
    Action["CLICK"] = "CLICK";
    Action["UPDATE"] = "UPDATE";
})(Action = exports.Action || (exports.Action = {}));
var ActionType;
(function (ActionType) {
    ActionType["CLICK"] = "APP::BUTTON::CLICK";
    ActionType["UPDATE"] = "APP::BUTTON::UPDATE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module ButtonGroup
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Action;
(function (Action) {
    Action["UPDATE"] = "UPDATE";
})(Action = exports.Action || (exports.Action = {}));
var ActionType;
(function (ActionType) {
    ActionType["UPDATE"] = "APP::BUTTON::UPDATE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Cart
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ActionType;
(function (ActionType) {
    ActionType["FETCH"] = "APP::CART::FETCH";
    ActionType["UPDATE"] = "APP::CART::UPDATE";
    ActionType["SET_CUSTOMER"] = "APP::CART::SET_CUSTOMER";
    ActionType["REMOVE_CUSTOMER"] = "APP::CART::REMOVE_CUSTOMER";
    ActionType["ADD_CUSTOMER_ADDRESS"] = "APP::CART::ADD_CUSTOMER_ADDRESS";
    ActionType["UPDATE_CUSTOMER_ADDRESS"] = "APP::CART::UPDATE_CUSTOMER_ADDRESS";
    ActionType["SET_DISCOUNT"] = "APP::CART::SET_DISCOUNT";
    ActionType["REMOVE_DISCOUNT"] = "APP::CART::REMOVE_DISCOUNT";
    ActionType["SET_PROPERTIES"] = "APP::CART::SET_PROPERTIES";
    ActionType["REMOVE_PROPERTIES"] = "APP::CART::REMOVE_PROPERTIES";
    ActionType["CLEAR"] = "APP::CART::CLEAR";
    ActionType["ADD_LINE_ITEM"] = "APP::CART::ADD_LINE_ITEM";
    ActionType["UPDATE_LINE_ITEM"] = "APP::CART::UPDATE_LINE_ITEM";
    ActionType["REMOVE_LINE_ITEM"] = "APP::CART::REMOVE_LINE_ITEM";
    ActionType["SET_LINE_ITEM_DISCOUNT"] = "APP::CART::SET_LINE_ITEM_DISCOUNT";
    ActionType["REMOVE_LINE_ITEM_DISCOUNT"] = "APP::CART::REMOVE_LINE_ITEM_DISCOUNT";
    ActionType["SET_LINE_ITEM_PROPERTIES"] = "APP::CART::SET_LINE_ITEM_PROPERTIES";
    ActionType["REMOVE_LINE_ITEM_PROPERTIES"] = "APP::CART::REMOVE_LINE_ITEM_PROPERTIES";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var Action;
(function (Action) {
    Action["FETCH"] = "FETCH";
    Action["UPDATE"] = "UPDATE";
    Action["SET_CUSTOMER"] = "SET_CUSTOMER";
    Action["REMOVE_CUSTOMER"] = "REMOVE_CUSTOMER";
    Action["ADD_CUSTOMER_ADDRESS"] = "ADD_CUSTOMER_ADDRESS";
    Action["UPDATE_CUSTOMER_ADDRESS"] = "UPDATE_CUSTOMER_ADDRESS";
    Action["SET_DISCOUNT"] = "SET_DISCOUNT";
    Action["REMOVE_DISCOUNT"] = "REMOVE_DISCOUNT";
    Action["SET_PROPERTIES"] = "SET_PROPERTIES";
    Action["REMOVE_PROPERTIES"] = "REMOVE_PROPERTIES";
    Action["CLEAR"] = "CLEAR";
    Action["ADD_LINE_ITEM"] = "ADD_LINE_ITEM";
    Action["UPDATE_LINE_ITEM"] = "UPDATE_LINE_ITEM";
    Action["REMOVE_LINE_ITEM"] = "REMOVE_LINE_ITEM";
    Action["SET_LINE_ITEM_DISCOUNT"] = "SET_LINE_ITEM_DISCOUNT";
    Action["REMOVE_LINE_ITEM_DISCOUNT"] = "REMOVE_LINE_ITEM_DISCOUNT";
    Action["SET_LINE_ITEM_PROPERTIES"] = "SET_LINE_ITEM_PROPERTIES";
    Action["REMOVE_LINE_ITEM_PROPERTIES"] = "REMOVE_LINE_ITEM_PROPERTIES";
})(Action = exports.Action || (exports.Action = {}));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Flash
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ActionType;
(function (ActionType) {
    ActionType["SHOW"] = "APP::FLASH::SHOW";
    ActionType["CLEAR"] = "APP::FLASH::CLEAR";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var Action;
(function (Action) {
    Action["SHOW"] = "SHOW";
    Action["CLEAR"] = "CLEAR";
})(Action = exports.Action || (exports.Action = {}));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Loading
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ActionType;
(function (ActionType) {
    ActionType["START"] = "APP::LOADING::START";
    ActionType["STOP"] = "APP::LOADING::STOP";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var Action;
(function (Action) {
    Action["START"] = "START";
    Action["STOP"] = "STOP";
})(Action = exports.Action || (exports.Action = {}));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Modal
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Action;
(function (Action) {
    Action["OPEN"] = "OPEN";
    Action["CLOSE"] = "CLOSE";
    Action["UPDATE"] = "UPDATE";
})(Action = exports.Action || (exports.Action = {}));
var ActionType;
(function (ActionType) {
    ActionType["OPEN"] = "APP::MODAL::OPEN";
    ActionType["CLOSE"] = "APP::MODAL::CLOSE";
    ActionType["UPDATE"] = "APP::MODAL::UPDATE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var FooterActionType;
(function (FooterActionType) {
    FooterActionType["FOOTER_BUTTON_CLICK"] = "APP::MODAL::FOOTER::BUTTON::CLICK";
    FooterActionType["FOOTER_BUTTON_UPDATE"] = "APP::MODAL::FOOTER::BUTTON::UPDATE";
})(FooterActionType = exports.FooterActionType || (exports.FooterActionType = {}));
var Size;
(function (Size) {
    Size["Small"] = "small";
    Size["Medium"] = "medium";
    Size["Large"] = "large";
    Size["Full"] = "full";
})(Size = exports.Size || (exports.Size = {}));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Error_1 = __webpack_require__(0);
var helper_2 = __webpack_require__(6);
var types_2 = __webpack_require__(7);
function push(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: types_1.Group.Navigation,
        type: types_2.ActionType.PUSH,
    });
}
exports.push = push;
function replace(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: types_1.Group.Navigation,
        type: types_2.ActionType.REPLACE,
    });
}
exports.replace = replace;
function validationError(action) {
    var payload;
    switch (action.type) {
        case types_2.ActionType.REPLACE:
        case types_2.ActionType.PUSH:
            payload = action.payload;
            if (payload === undefined) {
                return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
            }
            return helper_2.isValidAbsolutePath(payload.path) || helper_2.isValidRelativePath(payload.path)
                ? undefined
                : Error_1.invalidPayload(action, 'Invalid path provided. Expected a relative or absolute https or http path');
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
var History = /** @class */ (function (_super) {
    __extends(History, _super);
    function History(app) {
        return _super.call(this, app, 'History', types_1.Group.Navigation) || this;
    }
    Object.defineProperty(History.prototype, "payload", {
        get: function () {
            return { id: this.id };
        },
        enumerable: true,
        configurable: true
    });
    History.prototype.dispatch = function (type, path) {
        var payload = __assign({}, this.payload, { path: path });
        switch (type) {
            case types_2.Action.PUSH:
                this.app.dispatch(push(payload));
                break;
            case types_2.Action.REPLACE:
                this.app.dispatch(replace(payload));
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    type: type,
                    group: this.group,
                }));
        }
        return this;
    };
    return History;
}(helper_1.ActionSet));
exports.History = History;
function create(app) {
    return new History(app);
}
exports.create = create;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Redirect
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Error_1 = __webpack_require__(0);
var helper_2 = __webpack_require__(6);
var types_2 = __webpack_require__(8);
exports.GROUP = types_1.Group.Navigation;
function isResourcePayload(resource) {
    // tslint:disable-next-line:no-boolean-literal-compare
    return typeof resource.id === 'string';
}
exports.isResourcePayload = isResourcePayload;
function isCreateResourcePayload(resource) {
    // tslint:disable-next-line:no-boolean-literal-compare
    return resource.create === true;
}
exports.isCreateResourcePayload = isCreateResourcePayload;
function isProductVariantResourcePayload(resource) {
    var castResource = resource;
    // tslint:disable-next-line:no-boolean-literal-compare
    return castResource.id !== undefined && castResource.variant !== undefined;
}
exports.isProductVariantResourcePayload = isProductVariantResourcePayload;
function isProductVariantCreateResourcePayload(resource) {
    if (!isProductVariantResourcePayload(resource)) {
        return false;
    }
    return isCreateResourcePayload(resource.variant);
}
exports.isProductVariantCreateResourcePayload = isProductVariantCreateResourcePayload;
function toAdminPath(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.ADMIN_PATH,
    });
}
exports.toAdminPath = toAdminPath;
function toAdminSection(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.ADMIN_SECTION,
    });
}
exports.toAdminSection = toAdminSection;
function toRemote(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.REMOTE,
    });
}
exports.toRemote = toRemote;
function toApp(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.APP,
    });
}
exports.toApp = toApp;
function isValidAdminResource(section) {
    if (section === undefined) {
        return false;
    }
    var name = section.name, resource = section.resource;
    if (!name) {
        return false;
    }
    var valid = false;
    helper_1.forEachInEnum(types_2.ResourceType, function (resourceName) {
        if (name === resourceName) {
            valid = true;
        }
    });
    if (!valid) {
        return false;
    }
    return (resource === undefined ||
        isProductVariantResourcePayload(resource) ||
        isProductVariantCreateResourcePayload(resource) ||
        isCreateResourcePayload(resource) ||
        isResourcePayload(resource));
}
exports.isValidAdminResource = isValidAdminResource;
function validationError(action) {
    var payload;
    switch (action.type) {
        case types_2.ActionType.ADMIN_PATH:
            payload = action.payload;
            if (payload === undefined) {
                return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
            }
            return helper_2.isValidRelativePath(payload.path)
                ? undefined
                : Error_1.invalidPayload(action, 'Path is invalid. Expecting relative path');
        case types_2.ActionType.REMOTE:
            payload = action.payload;
            if (payload === undefined) {
                return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
            }
            return helper_2.isValidAbsolutePath(payload.url)
                ? undefined
                : Error_1.invalidPayload(action, 'Url is invalid. Expecting absolute url');
        case types_2.ActionType.APP:
            payload = action.payload;
            if (payload === undefined) {
                return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
            }
            return helper_2.isValidRelativePath(payload.path)
                ? undefined
                : Error_1.invalidPayload(action, 'Path is invalid. Expecting relative path');
        case types_2.ActionType.ADMIN_SECTION:
            payload = action.payload;
            if (payload === undefined) {
                return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
            }
            return isValidAdminResource(payload.section)
                ? undefined
                : Error_1.invalidPayload(action, 'Invalid admin section resource');
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
var Redirect = /** @class */ (function (_super) {
    __extends(Redirect, _super);
    function Redirect(app) {
        return _super.call(this, app, 'Redirect', types_1.Group.Navigation) || this;
    }
    Object.defineProperty(Redirect.prototype, "payload", {
        get: function () {
            return { id: this.id };
        },
        enumerable: true,
        configurable: true
    });
    Redirect.prototype.dispatch = function (action, payload) {
        switch (action) {
            case types_2.Action.ADMIN_PATH:
                this.app.dispatch(toAdminPath(__assign({}, this.payload, { path: payload })));
                break;
            case types_2.Action.ADMIN_SECTION:
                this.app.dispatch(toAdminSection(__assign({}, this.payload, { section: payload })));
                break;
            case types_2.Action.APP:
                this.app.dispatch(toApp(__assign({}, this.payload, { path: payload })));
                break;
            case types_2.Action.REMOTE:
                this.app.dispatch(toRemote(__assign({}, this.payload, { url: payload })));
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    type: action,
                }));
        }
        return this;
    };
    return Redirect;
}(helper_1.ActionSet));
exports.Redirect = Redirect;
function create(app) {
    return new Redirect(app);
}
exports.create = create;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Print
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ActionType;
(function (ActionType) {
    ActionType["APP"] = "APP::PRINT::APP";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var Action;
(function (Action) {
    Action["APP"] = "APP";
})(Action = exports.Action || (exports.Action = {}));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module ResourcePicker
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Action;
(function (Action) {
    Action["OPEN"] = "OPEN";
    Action["SELECT"] = "SELECT";
    Action["CLOSE"] = "CLOSE";
    Action["UPDATE"] = "UPDATE";
})(Action = exports.Action || (exports.Action = {}));
var ActionType;
(function (ActionType) {
    ActionType["OPEN"] = "APP::RESOURCE_PICKER::OPEN";
    ActionType["SELECT"] = "APP::RESOURCE_PICKER::SELECT";
    ActionType["CLOSE"] = "APP::RESOURCE_PICKER::CLOSE";
    ActionType["UPDATE"] = "APP::RESOURCE_PICKER::UPDATE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var FulfillmentServiceType;
(function (FulfillmentServiceType) {
    FulfillmentServiceType["GiftCard"] = "GIFT_CARD";
    FulfillmentServiceType["Manual"] = "MANUAL";
    FulfillmentServiceType["ThirdParty"] = "THIRD_PARTY";
})(FulfillmentServiceType = exports.FulfillmentServiceType || (exports.FulfillmentServiceType = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["Kilograms"] = "KILOGRAMS";
    WeightUnit["Grams"] = "GRAMS";
    WeightUnit["Pounds"] = "POUNDS";
    WeightUnit["Ounces"] = "OUNCES";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
var ProductVariantInventoryPolicy;
(function (ProductVariantInventoryPolicy) {
    ProductVariantInventoryPolicy["Deny"] = "DENY";
    ProductVariantInventoryPolicy["Continue"] = "CONTINUE";
})(ProductVariantInventoryPolicy = exports.ProductVariantInventoryPolicy || (exports.ProductVariantInventoryPolicy = {}));
var ProductVariantInventoryManagement;
(function (ProductVariantInventoryManagement) {
    ProductVariantInventoryManagement["Shopify"] = "SHOPIFY";
    ProductVariantInventoryManagement["NotManaged"] = "NOT_MANAGED";
    ProductVariantInventoryManagement["FulfillmentService"] = "FULFILLMENT_SERVICE";
})(ProductVariantInventoryManagement = exports.ProductVariantInventoryManagement || (exports.ProductVariantInventoryManagement = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["Product"] = "product";
    ResourceType["ProductVariant"] = "variant";
    ResourceType["Collection"] = "collection";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Action;
(function (Action) {
    Action["UPDATE"] = "UPDATE";
})(Action = exports.Action || (exports.Action = {}));
var ActionType;
(function (ActionType) {
    ActionType["UPDATE"] = "APP::TITLEBAR::UPDATE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ButtonsActionType;
(function (ButtonsActionType) {
    ButtonsActionType["BUTTON_CLICK"] = "APP::TITLEBAR::BUTTONS::BUTTON::CLICK";
    ButtonsActionType["BUTTON_UPDATE"] = "APP::TITLEBAR::BUTTONS::BUTTON::UPDATE";
    ButtonsActionType["BUTTON_GROUP_UPDATE"] = "APP::TITLEBAR::BUTTONS::BUTTONGROUP::UPDATE";
    ButtonsActionType["BREADCRUMBS_CLICK"] = "APP::TITLEBAR::BREADCRUMBS::BUTTON::CLICK";
    ButtonsActionType["BREADCRUMBS_UPDATE"] = "APP::TITLEBAR::BREADCRUMBS::BUTTON::UPDATE";
})(ButtonsActionType = exports.ButtonsActionType || (exports.ButtonsActionType = {}));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1));
var Button = __importStar(__webpack_require__(3));
exports.Button = Button;
var ButtonGroup = __importStar(__webpack_require__(4));
exports.ButtonGroup = ButtonGroup;
var Cart = __importStar(__webpack_require__(34));
exports.Cart = Cart;
var Error = __importStar(__webpack_require__(0));
exports.Error = Error;
var Flash = __importStar(__webpack_require__(36));
exports.Flash = Flash;
var Loading = __importStar(__webpack_require__(38));
exports.Loading = Loading;
var Modal = __importStar(__webpack_require__(40));
exports.Modal = Modal;
var Navigation = __importStar(__webpack_require__(43));
exports.Navigation = Navigation;
var History = __importStar(__webpack_require__(45));
exports.History = History;
var Redirect = __importStar(__webpack_require__(46));
exports.Redirect = Redirect;
var Print = __importStar(__webpack_require__(25));
exports.Print = Print;
var ResourcePicker = __importStar(__webpack_require__(48));
exports.ResourcePicker = ResourcePicker;
var TitleBar = __importStar(__webpack_require__(50));
exports.TitleBar = TitleBar;
var validator_1 = __webpack_require__(10);
exports.isAppBridgeAction = validator_1.isAppBridgeAction;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(47));
__export(__webpack_require__(21));


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var types_2 = __webpack_require__(11);
function errorActionWrapperWithId(type, action, message) {
    var castPayload = action.payload;
    return helper_1.actionWrapper({
        type: type,
        group: types_1.Group.Error,
        payload: {
            action: action,
            message: message,
            type: type,
            id: castPayload && castPayload.id ? castPayload.id : undefined,
        },
    });
}
var Message;
(function (Message) {
    Message["MISSING_PAYLOAD"] = "Missing payload";
    Message["INVALID_PAYLOAD_ID"] = "Id in payload is missing or invalid";
})(Message = exports.Message || (exports.Message = {}));
function invalidPayload(action, message) {
    return errorActionWrapperWithId(types_2.ActionType.INVALID_PAYLOAD, action, message || "The action's payload is missing required properties or has invalid properties");
}
exports.invalidPayload = invalidPayload;
function invalidActionType(action, message) {
    return helper_1.actionWrapper({
        group: types_1.Group.Error,
        payload: {
            action: action,
            message: message || 'The action type is invalid or unsupported',
            type: types_2.ActionType.INVALID_ACTION_TYPE,
        },
        type: types_2.ActionType.INVALID_ACTION_TYPE,
    });
}
exports.invalidActionType = invalidActionType;
function invalidAction(action, message) {
    return helper_1.actionWrapper({
        group: types_1.Group.Error,
        payload: {
            action: action,
            message: message || "The action's has missing/invalid values for `group`, `type` or `version`",
            type: types_2.ActionType.INVALID_ACTION,
        },
        type: types_2.ActionType.INVALID_ACTION,
    });
}
exports.invalidAction = invalidAction;
function unexpectedAction(action, message) {
    return helper_1.actionWrapper({
        group: types_1.Group.Error,
        payload: {
            action: action,
            message: message || 'Action cannot be called at this time',
            type: types_2.ActionType.UNEXPECTED_ACTION,
        },
        type: types_2.ActionType.UNEXPECTED_ACTION,
    });
}
exports.unexpectedAction = unexpectedAction;
function unsupportedOperationAction(action, message) {
    return errorActionWrapperWithId(types_2.ActionType.UNSUPPORTED_OPERATION, action, message || 'The action type is unsupported');
}
exports.unsupportedOperationAction = unsupportedOperationAction;
function persistenceAction(action, message) {
    return errorActionWrapperWithId(types_2.ActionType.PERSISTENCE, action, message || 'Action cannot be persisted on server');
}
exports.persistenceAction = persistenceAction;
function networkAction(action, message) {
    return errorActionWrapperWithId(types_2.ActionType.NETWORK, action, message || 'Network error');
}
exports.networkAction = networkAction;
function permissionAction(action, message) {
    return errorActionWrapperWithId(types_2.ActionType.PERMISSION, action, message || 'Action is not permitted');
}
exports.permissionAction = permissionAction;
function isErrorEventName(eventName) {
    var match = helper_1.findMatchInEnum(types_2.Action, eventName);
    return typeof match === 'string';
}
exports.isErrorEventName = isErrorEventName;
var AppBridgeError = /** @class */ (function () {
    function AppBridgeError(message) {
        this.name = 'AppBridgeError';
        this.message = message;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        }
        else {
            this.stack = new Error(this.message).stack;
        }
    }
    return AppBridgeError;
}());
exports.AppBridgeError = AppBridgeError;
AppBridgeError.prototype = Object.create(Error.prototype);
function fromAction(message, type, action) {
    var errorMessage = message ? type + ": " + message : type;
    var error = new AppBridgeError(errorMessage);
    error.action = action;
    error.type = type;
    return error;
}
exports.fromAction = fromAction;
function throwError() {
    var type = arguments[0];
    var message;
    var action;
    if (typeof arguments[1] === 'string') {
        message = arguments[1];
    }
    else {
        action = arguments[1];
        message = arguments[2] || '';
    }
    throw fromAction(message, type, action);
}
exports.throwError = throwError;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function mergeProps(obj, newObj) {
    if (newObj === undefined) {
        return undefined;
    }
    // If setting to a different object type, don't merge any props
    if (!Object.getPrototypeOf(obj).isPrototypeOf(newObj)) {
        return newObj;
    }
    var clone = {};
    Object.keys(newObj).forEach(function (key) {
        var exists = obj.hasOwnProperty(key);
        if (!exists) {
            clone[key] = newObj[key];
        }
        else {
            if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                clone[key] = mergeProps(obj[key], newObj[key]);
            }
            else {
                clone[key] = newObj[key];
            }
        }
    });
    // Copy old props that are not present in new object only if this is a simple object
    Object.keys(obj).forEach(function (key) {
        var exists = newObj.hasOwnProperty(key);
        if (!exists) {
            clone[key] = obj[key];
        }
    });
    // Set prototype of cloned object to match original
    Object.setPrototypeOf(clone, Object.getPrototypeOf(obj));
    return clone;
}
exports.default = mergeProps;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Convert a number or array of integers to a string of padded hex octets.
 */
function asHex(value) {
    return Array.from(value)
        .map(function (i) { return ("00" + i.toString(16)).slice(-2); })
        .join('');
}
/**
 * Attempt to securely generate random bytes/
 */
function getRandomBytes(size) {
    // SPRNG
    if (typeof Uint8Array === 'function' && window.crypto) {
        var buffer = new Uint8Array(size);
        var randomValues = window.crypto.getRandomValues(buffer);
        if (randomValues) {
            return randomValues;
        }
    }
    // Insecure random
    return Array.from(new Array(size), function () { return (Math.random() * 255) | 0; });
}
/**
 * Generate a RFC4122-compliant v4 UUID.
 *
 * @see http://www.ietf.org/rfc/rfc4122.txt
 */
function generateUuid() {
    var version = 64;
    var clockSeqHiAndReserved = getRandomBytes(1);
    var timeHiAndVersion = getRandomBytes(2);
    clockSeqHiAndReserved[0] &= 63 | 128;
    // tslint:disable-next-line:binary-expression-operand-order
    timeHiAndVersion[0] &= 15 | version;
    return [
        asHex(getRandomBytes(4)),
        '-',
        asHex(getRandomBytes(2)),
        '-',
        asHex(timeHiAndVersion),
        '-',
        asHex(clockSeqHiAndReserved),
        asHex(getRandomBytes(1)),
        '-',
        asHex(getRandomBytes(6)),
    ].join('');
}
exports.generateUuid = generateUuid;
// Default
exports.default = generateUuid;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {"name":"@shopify/app-bridge","version":"0.2.2","types":"index.d.ts","main":"index.js","files":["actions.js","actions.js.map","actions/","client/","index.d.ts","index.js","index.js.map","host.js","host.js.map","host/","types/*","util/"],"private":false,"publishConfig":{"access":"public","@shopify:registry":"https://registry.npmjs.org"},"repository":"git@github.com:Shopify/app-bridge.git","author":"Shopify Inc.","license":"MIT","scripts":{"build":"NODE_ENV=production webpack -p && tsc --project ./tsconfig.build.json --emitDeclarationOnly && echo \"/**\n * @module client\n */\n\nimport createClientApp from './client';\nexport * from './client';\nexport default createClientApp;\n\" > index.d.ts","build:docs":"typedoc src/actions --out docs/actions -name app-bridge/actions && typedoc src/host -name app-bridge/host --out docs/host && typedoc src/client -name app-bridge/client --out docs/client","check":"tsc -p ./tsconfig.json --pretty --noEmit","clean":"rm -rf ./**/*.d.ts ./actions* ./client* ./host* ./index* ./util","lint":"tslint -c ./tslint.json -p ./tsconfig.json -t codeFrame","prepublishOnly":"yarn run clean && yarn run build","start":"webpack-dev-server","test":"jest 'src'","test:CI":"CI=true yarn test:coverage","test:coverage":"yarn test --coverage --outputFile=coverage --maxWorkers 2","test:watch":"yarn test --watch","watch":"webpack --progress --watch"},"devDependencies":{"@shopify/shopify-express":"^1.0.0-alpha.7","@types/enzyme":"^2.8.12","@types/jest":"^22.2.0","@types/react":"^16.0.40","@types/react-dom":"^16.0.3","@types/react-hot-loader":"^3.0.4","@types/react-redux":"^5.0.9","@types/react-router-dom":"^4.0.8","@types/react-router-redux":"^5.0.8","@types/react-test-renderer":"15.5.4","@types/react-transition-group":"^2.0.6","@types/webpack-env":"^1.13.1","awesome-typescript-loader":"^3.4.1","babel-plugin-system-import-transformer":"^3.1.0","css-loader":"^0.28.7","enzyme":"3.3.0","enzyme-adapter-react-15":"^1.0.5","express-session":"^1.15.6","hoist-non-react-statics":"^2.5.0","html-webpack-plugin":"^2.30.1","jest":"22.4.2","postcss-shopify":"^1.0.0","prettier":"1.12.0","react":"^15.5.4","react-dom":"^15.5.4","react-redux":"^5.0.6","react-test-renderer":"15.5.4","react-transition-group":"^2.2.1","redux":"^3.7.2","redux-devtools-extension":"^2.13.2","style-loader":"^0.19.0","ts-jest":"^22.4.1","tslint":"^5.9.1","tslint-config-shopify":"^3.0.1","typedoc":"^0.10.0","typedoc-plugin-external-module-name":"^1.1.1","typedoc-plugin-markdown":"^1.0.14","typescript":"2.8.1","webpack":"^3.10.0","webpack-dev-server":"^2.9.5","webpack-fix-default-import-plugin":"^1.0.3"},"prettier":{"bracketSpacing":false,"printWidth":100,"singleQuote":true,"trailingComma":"all"},"jest":{"globals":{"ts-jest":{"babelConfig":{"plugins":["babel-plugin-system-import-transformer"],"sourceMaps":"inline"}}},"setupTestFrameworkScriptFile":"./test/setup.js","testRegex":".*\\.test\\.tsx?$","testURL":"https://app-bridge.myshopify.io/","transform":{".tsx?$":"<rootDir>/../../node_modules/ts-jest/preprocessor.js"},"moduleFileExtensions":["js","jsx","json","ts","tsx"],"collectCoverageFrom":["src/**/*.{js,jsx,ts,tsx}","!**/node_modules/**","!**/index.{ts,tsx}","!**/types.ts"],"moduleDirectories":["<rootDir>/node_modules","./node_modules","./src"],"moduleNameMapper":{"app-bridge/info":"<rootDir>/package.json"}}}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Button
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Error_1 = __webpack_require__(0);
var types_2 = __webpack_require__(13);
function getSafeButtonProps(props) {
    return helper_1.sanitizeProps(props, ['label', 'primary', 'disabled', 'id']);
}
exports.getSafeButtonProps = getSafeButtonProps;
function clickButton(group, component, payload) {
    var id = component.id;
    var action = helper_1.getEventNameSpace(group, types_2.Action.CLICK, component);
    var buttonPayload = {
        id: id,
        payload: payload,
    };
    return helper_1.actionWrapper({ type: action, group: group, payload: buttonPayload });
}
exports.clickButton = clickButton;
function update(group, component, props) {
    var id = component.id;
    var label = props.label;
    var action = helper_1.getEventNameSpace(group, types_2.Action.UPDATE, component);
    var buttonPayload = __assign({ id: id,
        label: label }, getSafeButtonProps(props));
    return helper_1.actionWrapper({ type: action, group: group, payload: buttonPayload });
}
exports.update = update;
function validationError(action) {
    if (!action.hasOwnProperty('payload')) {
        return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
    }
    var payload;
    switch (action.type) {
        case types_2.ActionType.CLICK:
            payload = action.payload;
            return typeof payload.id === 'string'
                ? undefined
                : Error_1.invalidPayload(action, Error_1.Message.INVALID_PAYLOAD_ID);
        case types_2.ActionType.UPDATE:
            payload = action.payload;
            return isValidButtonProps(payload) ? undefined : Error_1.invalidPayload(action);
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
function isValidButtonProps(button) {
    return typeof button.id === 'string' && typeof button.label === 'string';
}
exports.isValidButtonProps = isValidButtonProps;
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(app, options) {
        var _this = _super.call(this, app, types_1.ComponentType.Button, types_1.Group.Button) || this;
        _this.primary = false;
        _this.disabled = false;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(Button.prototype, "options", {
        get: function () {
            return {
                disabled: this.disabled,
                label: this.label,
                primary: this.primary,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "payload", {
        get: function () {
            return __assign({ id: this.id }, this.options);
        },
        enumerable: true,
        configurable: true
    });
    Button.prototype.set = function (options, shouldUpdate) {
        if (shouldUpdate === void 0) { shouldUpdate = true; }
        var mergedOptions = helper_1.getMergedProps(this.options, options);
        var label = mergedOptions.label, primary = mergedOptions.primary, disabled = mergedOptions.disabled;
        if (!this.validateOptions(mergedOptions)) {
            return this;
        }
        this.label = label;
        this.primary = !!primary;
        this.disabled = !!disabled;
        if (shouldUpdate) {
            this.dispatch(types_2.Action.UPDATE);
        }
        return this;
    };
    Button.prototype.dispatch = function (action, payload) {
        switch (action) {
            case types_2.Action.CLICK:
                this.app.dispatch(clickButton(this.group, this.component, payload));
                break;
            case types_2.Action.UPDATE:
                var updateAction = update(this.group, this.component, this.payload);
                this.app.dispatch(updateAction);
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    payload: this.payload,
                    type: action,
                }));
        }
        return this;
    };
    Button.prototype.validateOptions = function (options) {
        var buttonProps = __assign({ id: this.id }, options);
        if (!isValidButtonProps(buttonProps)) {
            var errorAction = update(this.group, this.component, buttonProps);
            Error_1.throwError(Error_1.ActionType.INVALID_OPTIONS, errorAction);
            return false;
        }
        return true;
    };
    return Button;
}(helper_1.ActionSet));
exports.Button = Button;
function create(app, options) {
    return new Button(app, options);
}
exports.create = create;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module ButtonGroup
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var buttonHelper_1 = __webpack_require__(5);
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Button_1 = __webpack_require__(3);
var Error_1 = __webpack_require__(0);
var types_2 = __webpack_require__(14);
function update(group, component, props) {
    return buttonActionWrapper(group, component, types_2.Action.UPDATE, props);
}
exports.update = update;
function isGroupedButton(options) {
    var castOptions = options;
    return castOptions.buttons && castOptions.buttons.length > 0 && castOptions.label !== undefined;
}
exports.isGroupedButton = isGroupedButton;
function isGroupedButtonPayload(payload) {
    var castOptions = payload;
    return (Array.isArray(castOptions.buttons) &&
        typeof castOptions.id === 'string' &&
        typeof castOptions.label === 'string');
}
exports.isGroupedButtonPayload = isGroupedButtonPayload;
function getSafeButtonGroupProps(props) {
    return helper_1.sanitizeProps(props, ['label', 'disabled', 'buttons', 'id']);
}
exports.getSafeButtonGroupProps = getSafeButtonGroupProps;
function validationError(action) {
    if (!action.hasOwnProperty('payload')) {
        return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
    }
    switch (action.type) {
        case types_2.ActionType.UPDATE:
            var payload = action.payload;
            return isValidButtonGroupProps(payload) ? undefined : Error_1.invalidPayload(action);
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
function isValidButtonGroupProps(buttonGroup) {
    if (typeof buttonGroup.id !== 'string' ||
        typeof buttonGroup.label !== 'string' ||
        !Array.isArray(buttonGroup.buttons)) {
        return false;
    }
    for (var _i = 0, _a = buttonGroup.buttons; _i < _a.length; _i++) {
        var button = _a[_i];
        if (!Button_1.isValidButtonProps(button)) {
            return false;
        }
    }
    return true;
}
exports.isValidButtonGroupProps = isValidButtonGroupProps;
var ButtonGroup = /** @class */ (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup(app, options) {
        var _this = _super.call(this, app, types_1.ComponentType.ButtonGroup, types_1.Group.ButtonGroup) || this;
        _this.disabled = false;
        _this.buttonsOptions = [];
        _this.buttons = [];
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ButtonGroup.prototype, "options", {
        get: function () {
            return {
                buttons: this.buttonsOptions,
                disabled: this.disabled,
                label: this.label,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonGroup.prototype, "payload", {
        get: function () {
            return __assign({}, this.options, { buttons: this.buttons, id: this.id });
        },
        enumerable: true,
        configurable: true
    });
    ButtonGroup.prototype.set = function (options, shouldUpdate) {
        if (shouldUpdate === void 0) { shouldUpdate = true; }
        var mergedOptions = helper_1.getMergedProps(this.options, options);
        var label = mergedOptions.label, disabled = mergedOptions.disabled, buttons = mergedOptions.buttons;
        if (!this.validateOptions(mergedOptions)) {
            return this;
        }
        this.label = label;
        this.disabled = !!disabled;
        this.buttons = this.getButtons(buttons);
        if (shouldUpdate) {
            this.dispatch(types_2.Action.UPDATE);
        }
        return this;
    };
    ButtonGroup.prototype.dispatch = function (action) {
        switch (action) {
            case types_2.Action.UPDATE:
                var updateAction = update(this.group, this.component, this.payload);
                this.app.dispatch(updateAction);
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    type: action,
                }));
        }
        return this;
    };
    ButtonGroup.prototype.updateButtons = function (newPayload) {
        if (!this.buttons || this.buttons.length === 0) {
            return;
        }
        var updated;
        for (var _i = 0, _a = this.buttons; _i < _a.length; _i++) {
            var action = _a[_i];
            updated = helper_1.updateActionFromPayload(action, Button_1.getSafeButtonProps(newPayload));
            if (updated) {
                break;
            }
        }
        if (updated) {
            this.dispatch(types_2.Action.UPDATE);
        }
    };
    ButtonGroup.prototype.getSingleButton = function (button) {
        return buttonHelper_1.getSingleButton(this, button, this.subgroups, this.updateButtons);
    };
    ButtonGroup.prototype.getButtons = function (buttonOptions) {
        var _this = this;
        var buttons = [];
        if (!buttonOptions) {
            return [];
        }
        buttonOptions.forEach(function (button) {
            var singleButton = buttonHelper_1.getSingleButton(_this, button, _this.subgroups, _this.updateButtons);
            buttons.push(singleButton);
        });
        this.buttonsOptions = buttonOptions;
        return buttons;
    };
    ButtonGroup.prototype.validateOptions = function (options) {
        var buttonGroupProps = __assign({ id: this.id }, options);
        if (!isValidButtonGroupProps(buttonGroupProps)) {
            var errorAction = update(this.group, this.component, buttonGroupProps);
            Error_1.throwError(Error_1.ActionType.INVALID_OPTIONS, errorAction);
            return false;
        }
        return true;
    };
    return ButtonGroup;
}(helper_1.ActionSetWithChildren));
exports.ButtonGroup = ButtonGroup;
function create(app, options) {
    return new ButtonGroup(app, options);
}
exports.create = create;
function buttonActionWrapper(group, component, eventName, props, payload) {
    var id = component.id;
    var label = props.label;
    var action = helper_1.getEventNameSpace(group, eventName, component);
    var buttonPayload = __assign({ id: id,
        label: label }, getSafeButtonGroupProps(props), { payload: payload });
    return helper_1.actionWrapper({ type: action, group: group, payload: buttonPayload });
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(35));
__export(__webpack_require__(15));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Cart
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Error_1 = __webpack_require__(0);
var types_2 = __webpack_require__(15);
/**
 * Validation
 */
function isValidAddress(address) {
    return (helper_1.isValidOptionalString(address.address1) &&
        helper_1.isValidOptionalString(address.address2) &&
        helper_1.isValidOptionalString(address.city) &&
        helper_1.isValidOptionalString(address.company) &&
        helper_1.isValidOptionalString(address.firstName) &&
        helper_1.isValidOptionalString(address.lastName) &&
        helper_1.isValidOptionalString(address.phone) &&
        helper_1.isValidOptionalString(address.provice) &&
        helper_1.isValidOptionalString(address.country) &&
        helper_1.isValidOptionalString(address.zip) &&
        helper_1.isValidOptionalString(address.name) &&
        helper_1.isValidOptionalString(address.proviceCode) &&
        helper_1.isValidOptionalString(address.countryCode));
}
function isValidAddresses(addresses) {
    if (!addresses) {
        return true;
    }
    return Array.isArray(addresses) && addresses.every(isValidAddress);
}
function isValidCart(cart) {
    return ((cart.cartDiscount === undefined || isValidDiscount(cart.cartDiscount)) &&
        (cart.customer === undefined ||
            isValidCustomer(cart.customer) ||
            isValidAddresses(cart.customer.addresses)) &&
        helper_1.isValidOptionalString(cart.grandTotal) &&
        (cart.lineItems === undefined || isValidLineItems(cart.lineItems)) &&
        isValidNoteAttributes(cart.noteAttributes) &&
        helper_1.isValidOptionalString(cart.subTotal) &&
        helper_1.isValidOptionalString(cart.taxTotal));
}
function isValidCustomer(customer) {
    return (helper_1.isValidOptionalNumber(customer.id) &&
        helper_1.isValidOptionalString(customer.email) &&
        helper_1.isValidOptionalString(customer.firstName) &&
        helper_1.isValidOptionalString(customer.lastName) &&
        helper_1.isValidOptionalString(customer.note));
}
function isValidDiscount(discount) {
    return (helper_1.isValidOptionalNumber(discount.amount) &&
        helper_1.isValidOptionalString(discount.discountDescription) &&
        helper_1.isValidOptionalString(discount.type));
}
function isValidLineItem(lineItem) {
    return (helper_1.isValidOptionalNumber(lineItem.price) &&
        typeof lineItem.quantity === 'number' &&
        helper_1.isValidOptionalString(lineItem.title) &&
        helper_1.isValidOptionalNumber(lineItem.variantId));
}
function isValidLineItems(lineItems) {
    if (!lineItems) {
        return true;
    }
    return Array.isArray(lineItems) && lineItems.every(isValidLineItem);
}
function isValidNoteAttributes(noteAttributes) {
    return (noteAttributes === undefined ||
        (Array.isArray(noteAttributes) &&
            noteAttributes.every(function (note) { return typeof note.name === 'string' && typeof note.value === 'string'; })));
}
function isValidProperties(properties) {
    return (typeof properties === 'object' &&
        !Array.isArray(properties) &&
        Object.keys(properties).every(function (key) { return typeof properties[key] === 'string'; }));
}
function isValidPropertiesKey(keys) {
    return Array.isArray(keys) && keys.every(function (key) { return typeof key === 'string'; });
}
function validationError(action) {
    if (!action.payload || typeof action.payload.id !== 'string') {
        return Error_1.invalidPayload(action, 'Missing payload id');
    }
    var payload;
    switch (action.type) {
        case types_2.ActionType.FETCH:
            return undefined;
        case types_2.ActionType.UPDATE:
            payload = action.payload;
            return !payload.data || !isValidCart(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid update payload')
                : undefined;
        case types_2.ActionType.SET_CUSTOMER:
            payload = action.payload;
            return !payload.data || !isValidCustomer(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid set customer payload')
                : undefined;
        case types_2.ActionType.REMOVE_CUSTOMER:
            return undefined;
        case types_2.ActionType.ADD_CUSTOMER_ADDRESS:
            payload = action.payload;
            return !payload.data || !isValidAddress(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid add customer address payload')
                : undefined;
        case types_2.ActionType.UPDATE_CUSTOMER_ADDRESS:
            payload = action.payload;
            return !payload.data || typeof payload.index !== 'number' || !isValidAddress(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid update customer address payload')
                : undefined;
        case types_2.ActionType.SET_DISCOUNT:
            payload = action.payload;
            return !payload.data || !isValidDiscount(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid set discount payload')
                : undefined;
        case types_2.ActionType.REMOVE_DISCOUNT:
            return undefined;
        case types_2.ActionType.SET_PROPERTIES:
            payload = action.payload;
            return !payload.data || !isValidProperties(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid add properties payload')
                : undefined;
        case types_2.ActionType.REMOVE_PROPERTIES:
            payload = action.payload;
            return !payload.data || !isValidPropertiesKey(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid remove properties payload')
                : undefined;
        case types_2.ActionType.CLEAR:
            return undefined;
        case types_2.ActionType.ADD_LINE_ITEM:
            payload = action.payload;
            return !payload.data || !isValidLineItem(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid add line item payload')
                : undefined;
        case types_2.ActionType.UPDATE_LINE_ITEM:
            payload = action.payload;
            return !payload.data ||
                typeof payload.index !== 'number' ||
                typeof payload.data.quantity !== 'number'
                ? Error_1.invalidPayload(action, 'Invalid update line item payload')
                : undefined;
        case types_2.ActionType.REMOVE_LINE_ITEM:
            payload = action.payload;
            return typeof payload.index !== 'number'
                ? Error_1.invalidPayload(action, 'Invalid remove line item payload')
                : undefined;
        case types_2.ActionType.SET_LINE_ITEM_DISCOUNT:
            payload = action.payload;
            return !payload.data || typeof payload.index !== 'number' || !isValidDiscount(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid set line item discount payload')
                : undefined;
        case types_2.ActionType.REMOVE_LINE_ITEM_DISCOUNT:
            payload = action.payload;
            return typeof payload.index !== 'number'
                ? Error_1.invalidPayload(action, 'Invalid remove line item discount payload')
                : undefined;
        case types_2.ActionType.SET_LINE_ITEM_PROPERTIES:
            payload = action.payload;
            return !payload.data || typeof payload.index !== 'number' || !isValidProperties(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid add line item properties payload')
                : undefined;
        case types_2.ActionType.REMOVE_LINE_ITEM_PROPERTIES:
            payload = action.payload;
            return !payload.data ||
                typeof payload.index !== 'number' ||
                !isValidPropertiesKey(payload.data)
                ? Error_1.invalidPayload(action, 'Invalid remove line item properties payload')
                : undefined;
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
/**
 * Cart
 */
var Cart = /** @class */ (function (_super) {
    __extends(Cart, _super);
    function Cart(app, options) {
        return _super.call(this, app, types_1.Group.Cart, types_1.Group.Cart, options ? options.id : undefined) || this;
    }
    Cart.prototype.dispatch = function (action, payload) {
        switch (action) {
            case types_2.Action.FETCH:
                this.dispatchCartAction(types_2.ActionType.FETCH);
                break;
            case types_2.Action.UPDATE:
                this.dispatchCartAction(types_2.ActionType.UPDATE, payload);
                break;
            case types_2.Action.SET_CUSTOMER:
                this.dispatchCartAction(types_2.ActionType.SET_CUSTOMER, payload);
                break;
            case types_2.Action.REMOVE_CUSTOMER:
                this.dispatchCartAction(types_2.ActionType.REMOVE_CUSTOMER, payload);
                break;
            case types_2.Action.ADD_CUSTOMER_ADDRESS:
                this.dispatchCartAction(types_2.ActionType.ADD_CUSTOMER_ADDRESS, payload);
                break;
            case types_2.Action.UPDATE_CUSTOMER_ADDRESS:
                this.dispatchCartAction(types_2.ActionType.UPDATE_CUSTOMER_ADDRESS, payload);
                break;
            case types_2.Action.SET_DISCOUNT:
                this.dispatchCartAction(types_2.ActionType.SET_DISCOUNT, payload);
                break;
            case types_2.Action.REMOVE_DISCOUNT:
                this.dispatchCartAction(types_2.ActionType.REMOVE_DISCOUNT, payload);
                break;
            case types_2.Action.SET_PROPERTIES:
                this.dispatchCartAction(types_2.ActionType.SET_PROPERTIES, payload);
                break;
            case types_2.Action.REMOVE_PROPERTIES:
                this.dispatchCartAction(types_2.ActionType.REMOVE_PROPERTIES, payload);
                break;
            case types_2.Action.CLEAR:
                this.dispatchCartAction(types_2.ActionType.CLEAR, payload);
                break;
            case types_2.Action.ADD_LINE_ITEM:
                this.dispatchCartAction(types_2.ActionType.ADD_LINE_ITEM, payload);
                break;
            case types_2.Action.UPDATE_LINE_ITEM:
                this.dispatchCartAction(types_2.ActionType.UPDATE_LINE_ITEM, payload);
                break;
            case types_2.Action.REMOVE_LINE_ITEM:
                this.dispatchCartAction(types_2.ActionType.REMOVE_LINE_ITEM, payload);
                break;
            case types_2.Action.SET_LINE_ITEM_DISCOUNT:
                this.dispatchCartAction(types_2.ActionType.SET_LINE_ITEM_DISCOUNT, payload);
                break;
            case types_2.Action.REMOVE_LINE_ITEM_DISCOUNT:
                this.dispatchCartAction(types_2.ActionType.REMOVE_LINE_ITEM_DISCOUNT, payload);
                break;
            case types_2.Action.SET_LINE_ITEM_PROPERTIES:
                this.dispatchCartAction(types_2.ActionType.SET_LINE_ITEM_PROPERTIES, payload);
                break;
            case types_2.Action.REMOVE_LINE_ITEM_PROPERTIES:
                this.dispatchCartAction(types_2.ActionType.REMOVE_LINE_ITEM_PROPERTIES, payload);
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    type: action,
                }));
        }
        return this;
    };
    Cart.prototype.dispatchCartAction = function (type, payload) {
        this.app.dispatch(helper_1.actionWrapper({
            type: type,
            group: types_1.Group.Cart,
            payload: __assign({}, (payload || {}), { id: this.id }),
        }));
    };
    return Cart;
}(helper_1.ActionSet));
exports.Cart = Cart;
function create(app, options) {
    return new Cart(app, options);
}
exports.create = create;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(37));
__export(__webpack_require__(16));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Flash
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Error_1 = __webpack_require__(0);
var types_2 = __webpack_require__(16);
function show(flashMessage) {
    return helper_1.actionWrapper({
        group: types_1.Group.Flash,
        payload: flashMessage,
        type: types_2.ActionType.SHOW,
    });
}
exports.show = show;
function clear(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: types_1.Group.Flash,
        type: types_2.ActionType.CLEAR,
    });
}
exports.clear = clear;
function validationError(action) {
    var payload;
    switch (action.type) {
        case types_2.ActionType.CLEAR:
            payload = action.payload;
            return payload === undefined || (payload.id === undefined || typeof payload.id === 'string')
                ? undefined
                : Error_1.invalidPayload(action, 'Id in payload is invalid');
        case types_2.ActionType.SHOW:
            payload = action.payload;
            return payload !== undefined &&
                (payload.id === undefined || typeof payload.id === 'string') &&
                isValidFlashProps(payload)
                ? undefined
                : Error_1.invalidPayload(action);
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
function isValidFlashProps(props) {
    return typeof props.message === 'string' && typeof props.duration === 'number';
}
var Flash = /** @class */ (function (_super) {
    __extends(Flash, _super);
    function Flash(app, options) {
        var _this = _super.call(this, app, types_1.Group.Flash, types_1.Group.Flash) || this;
        _this.message = '';
        _this.duration = 3000;
        _this.set(options);
        return _this;
    }
    Object.defineProperty(Flash.prototype, "options", {
        get: function () {
            return {
                duration: this.duration,
                isDismissible: this.isDismissible,
                isError: this.isError,
                message: this.message,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Flash.prototype, "payload", {
        get: function () {
            return __assign({ id: this.id }, this.options);
        },
        enumerable: true,
        configurable: true
    });
    Flash.prototype.set = function (options) {
        var mergedOptions = helper_1.getMergedProps(this.options, options);
        var message = mergedOptions.message, isDismissible = mergedOptions.isDismissible, duration = mergedOptions.duration, isError = mergedOptions.isError;
        if (!this.validateOptions(mergedOptions)) {
            return this;
        }
        this.message = message;
        this.isDismissible = isDismissible;
        this.duration = duration;
        this.isError = isError;
        return this;
    };
    Flash.prototype.dispatch = function (action) {
        switch (action) {
            case types_2.Action.SHOW:
                var openAction = show(this.payload);
                this.app.dispatch(openAction);
                break;
            case types_2.Action.CLEAR:
                this.app.dispatch(clear({ id: this.id }));
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    type: action,
                }));
        }
        return this;
    };
    Flash.prototype.validateOptions = function (options) {
        if (!isValidFlashProps(options)) {
            var errorAction = helper_1.actionWrapper({
                group: types_1.Group.Flash,
                payload: __assign({ id: this.id }, options),
            });
            Error_1.throwError(Error_1.ActionType.INVALID_OPTIONS, errorAction);
            return false;
        }
        return true;
    };
    return Flash;
}(helper_1.ActionSet));
exports.Flash = Flash;
function create(app, options) {
    return new Flash(app, options);
}
exports.create = create;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(39));
__export(__webpack_require__(17));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Loading
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Error_1 = __webpack_require__(0);
var types_2 = __webpack_require__(17);
function start(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: types_1.Group.Loading,
        type: types_2.ActionType.START,
    });
}
exports.start = start;
function stop(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: types_1.Group.Loading,
        type: types_2.ActionType.STOP,
    });
}
exports.stop = stop;
function validationError(action) {
    switch (action.type) {
        case types_2.ActionType.START:
        case types_2.ActionType.STOP:
            // No validation since there should not be a payload
            return undefined;
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
var Loading = /** @class */ (function (_super) {
    __extends(Loading, _super);
    function Loading(app) {
        return _super.call(this, app, types_1.Group.Loading, types_1.Group.Loading) || this;
    }
    Object.defineProperty(Loading.prototype, "payload", {
        get: function () {
            return { id: this.id };
        },
        enumerable: true,
        configurable: true
    });
    Loading.prototype.dispatch = function (action) {
        switch (action) {
            case types_2.Action.START:
                this.app.dispatch(start(this.payload));
                break;
            case types_2.Action.STOP:
                this.app.dispatch(stop(this.payload));
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    type: action,
                }));
        }
        return this;
    };
    return Loading;
}(helper_1.ActionSet));
exports.Loading = Loading;
function create(app) {
    return new Loading(app);
}
exports.create = create;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(41));
__export(__webpack_require__(18));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var safe_redirect_1 = __webpack_require__(42);
var buttonHelper_1 = __webpack_require__(5);
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Button_1 = __webpack_require__(3);
var Error_1 = __webpack_require__(0);
var helper_2 = __webpack_require__(6);
var types_2 = __webpack_require__(18);
exports.GROUP = types_1.Group.Modal;
var FOOTER_BUTTON_PROPS = {
    group: exports.GROUP,
    subgroups: ['Footer'],
    type: types_1.ComponentType.Button,
};
function openModal(modalPayload) {
    return helper_1.actionWrapper({
        group: exports.GROUP,
        payload: modalPayload,
        type: types_2.ActionType.OPEN,
    });
}
exports.openModal = openModal;
function closeModal(modalClosePayload) {
    return helper_1.actionWrapper({
        group: exports.GROUP,
        payload: modalClosePayload,
        type: types_2.ActionType.CLOSE,
    });
}
exports.closeModal = closeModal;
function clickFooterButton(id, payload) {
    var component = __assign({ id: id }, FOOTER_BUTTON_PROPS);
    return Button_1.clickButton(exports.GROUP, component, payload);
}
exports.clickFooterButton = clickFooterButton;
function update(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.UPDATE,
    });
}
exports.update = update;
function isValidSrc(options, localOrigin) {
    var url = options.url, path = options.path;
    if (!url && !path) {
        return false;
    }
    if (path && !helper_2.isValidRelativePath(path)) {
        return false;
    }
    if (url) {
        if (!localOrigin) {
            return false;
        }
        if (!helper_2.isValidAbsolutePath(url)) {
            return false;
        }
        var hostName = void 0;
        try {
            hostName = new URL(localOrigin).hostname;
        }
        catch (error) {
            return false;
        }
        var isSafeSrc = safe_redirect_1.isSafe(url, {
            requireAbsolute: true,
            requireSSL: true,
            whitelist: [hostName],
        });
        if (!isSafeSrc) {
            return false;
        }
    }
    return true;
}
exports.isValidSrc = isValidSrc;
function validationError(action, localOrigin) {
    var payload;
    switch (action.type) {
        case types_2.ActionType.OPEN:
            payload = action.payload;
            if (payload === undefined) {
                return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
            }
            if (payload.id && typeof payload.id !== 'string') {
                return Error_1.invalidPayload(action, Error_1.Message.INVALID_PAYLOAD_ID);
            }
            return isValidModalProps(payload, localOrigin) ? undefined : Error_1.invalidPayload(action);
        case types_2.ActionType.UPDATE:
            payload = action.payload;
            if (payload === undefined) {
                return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
            }
            if (typeof payload.id !== 'string') {
                return Error_1.invalidPayload(action, Error_1.Message.INVALID_PAYLOAD_ID);
            }
            // Id is always required when updating
            return isValidModalProps(payload, localOrigin) ? undefined : Error_1.invalidPayload(action);
        case types_2.ActionType.CLOSE:
            payload = action.payload;
            if (payload && payload.id && typeof payload.id !== 'string') {
                return Error_1.invalidPayload(action, Error_1.Message.INVALID_PAYLOAD_ID);
            }
            return undefined;
        case types_2.FooterActionType.FOOTER_BUTTON_CLICK:
            return Button_1.validationError(__assign({}, action, { type: Button_1.ActionType.CLICK }));
        case types_2.FooterActionType.FOOTER_BUTTON_UPDATE:
            return Button_1.validationError(__assign({}, action, { type: Button_1.ActionType.UPDATE }));
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
function isValidModalProps(props, localOrigin) {
    if (props === undefined) {
        return false;
    }
    if (isIframeModal(props) &&
        (typeof localOrigin !== 'string' || !isValidSrc(props, localOrigin))) {
        return false;
    }
    return ((isMessageModal(props) || isIframeModal(props)) &&
        isValidModalFooter(props.footer) &&
        isValidModalSize(props.size));
}
exports.isValidModalProps = isValidModalProps;
function isValidModalFooter(footer) {
    if (footer === undefined || !footer.hasOwnProperty('buttons')) {
        return true;
    }
    if (footer.hasOwnProperty('buttons') &&
        (Array.isArray(footer.buttons) || typeof footer.buttons !== 'object')) {
        return false;
    }
    var _a = footer.buttons, secondary = _a.secondary, primary = _a.primary;
    if (primary && !Button_1.isValidButtonProps(primary)) {
        return false;
    }
    if (secondary && !Array.isArray(secondary)) {
        return false;
    }
    else if (Array.isArray(secondary)) {
        for (var _i = 0, secondary_1 = secondary; _i < secondary_1.length; _i++) {
            var button = secondary_1[_i];
            if (!Button_1.isValidButtonProps(button)) {
                return false;
            }
        }
    }
    return true;
}
exports.isValidModalFooter = isValidModalFooter;
function isValidModalSize(size) {
    if (size === undefined) {
        return true;
    }
    var valid = false;
    helper_1.forEachInEnum(types_2.Size, function (sizeOption) {
        if (size === sizeOption) {
            valid = true;
        }
    });
    return valid;
}
exports.isValidModalSize = isValidModalSize;
function isIframeModal(options) {
    return (typeof options.url === 'string' ||
        typeof options.path === 'string');
}
exports.isIframeModal = isIframeModal;
function isMessageModal(options) {
    return typeof options.message === 'string';
}
exports.isMessageModal = isMessageModal;
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = types_2.Size.Small;
        return _this;
    }
    Object.defineProperty(Modal.prototype, "footer", {
        get: function () {
            if (!this.footerPrimary && !this.footerSecondary) {
                return undefined;
            }
            return {
                buttons: {
                    primary: this.footerPrimary,
                    secondary: this.footerSecondary,
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "footerOptions", {
        get: function () {
            if (!this.footerPrimaryOptions && !this.footerSecondaryOptions) {
                return undefined;
            }
            return {
                buttons: {
                    primary: this.footerPrimaryOptions,
                    secondary: this.footerSecondaryOptions,
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    Modal.prototype.close = function () {
        this.app.dispatch(closeModal({ id: this.id }));
    };
    Modal.prototype.setFooterPrimaryButton = function (newOptions, updateCb) {
        var _this = this;
        var subgroups = FOOTER_BUTTON_PROPS.subgroups;
        this.footerPrimaryOptions = this.getChildButton(newOptions, this.footerPrimaryOptions);
        this.footerPrimary = this.footerPrimaryOptions
            ? buttonHelper_1.getSingleButton(this, this.footerPrimaryOptions, subgroups, function (newPayload) {
                _this.updatePrimaryFooterButton(newPayload, updateCb);
            })
            : undefined;
    };
    Modal.prototype.setFooterSecondaryButtons = function (newOptions, updateCb) {
        var _this = this;
        var subgroups = FOOTER_BUTTON_PROPS.subgroups;
        var newButtons = newOptions || [];
        var currentOptions = (this.footerOptions && this.footerOptions.buttons.secondary) || [];
        this.footerSecondaryOptions = this.getUpdatedChildActions(newButtons, currentOptions);
        this.footerSecondary = this.footerSecondaryOptions
            ? this.footerSecondaryOptions.map(function (action) {
                return buttonHelper_1.getSingleButton(_this, action, subgroups, function (newPayload) {
                    _this.updateSecondaryFooterButton(newPayload, updateCb);
                });
            })
            : undefined;
    };
    Modal.prototype.getChildButton = function (newAction, currentAction) {
        var newButtons = newAction ? [newAction] : [];
        var currentButtons = currentAction ? [currentAction] : [];
        var updatedButton = this.getUpdatedChildActions(newButtons, currentButtons);
        return updatedButton ? updatedButton[0] : undefined;
    };
    Modal.prototype.updatePrimaryFooterButton = function (newPayload, updateCb) {
        if (!this.footer || !this.footer.buttons.primary) {
            return;
        }
        if (helper_1.updateActionFromPayload(this.footer.buttons.primary, Button_1.getSafeButtonProps(newPayload))) {
            updateCb();
        }
    };
    Modal.prototype.updateSecondaryFooterButton = function (newPayload, updateCb) {
        if (!this.footer || !this.footer.buttons || !this.footer.buttons.secondary) {
            return;
        }
        var updated;
        for (var _i = 0, _a = this.footer.buttons.secondary; _i < _a.length; _i++) {
            var action = _a[_i];
            updated = helper_1.updateActionFromPayload(action, Button_1.getSafeButtonProps(newPayload));
            if (updated) {
                break;
            }
        }
        if (updated) {
            updateCb();
        }
    };
    Modal.prototype.validateOptions = function (options) {
        var props = __assign({ id: this.id }, options);
        if (!isValidModalProps(options, this.app.localOrigin)) {
            var errorAction = update(props);
            Error_1.throwError(Error_1.ActionType.INVALID_OPTIONS, errorAction);
            return false;
        }
        return true;
    };
    return Modal;
}(helper_1.ActionSetWithChildren));
exports.Modal = Modal;
var ModalMessage = /** @class */ (function (_super) {
    __extends(ModalMessage, _super);
    function ModalMessage(app, options) {
        var _this = _super.call(this, app, exports.GROUP, exports.GROUP) || this;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ModalMessage.prototype, "payload", {
        get: function () {
            return __assign({}, this.options, { footer: this.footer, id: this.id });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModalMessage.prototype, "options", {
        get: function () {
            return {
                footer: this.footerOptions,
                message: this.message,
                size: this.size,
                title: this.title,
            };
        },
        enumerable: true,
        configurable: true
    });
    ModalMessage.prototype.set = function (options, shouldUpdate) {
        var _this = this;
        if (shouldUpdate === void 0) { shouldUpdate = true; }
        var mergedOptions = helper_1.getMergedProps(this.options, options);
        var title = mergedOptions.title, footer = mergedOptions.footer, message = mergedOptions.message, size = mergedOptions.size;
        if (!this.validateOptions(mergedOptions)) {
            return this;
        }
        this.title = title;
        this.message = message;
        this.size = size;
        this.setFooterPrimaryButton(footer ? footer.buttons.primary : undefined, function () {
            _this.dispatch(types_2.Action.UPDATE);
        });
        this.setFooterSecondaryButtons(footer ? footer.buttons.secondary : undefined, function () {
            _this.dispatch(types_2.Action.UPDATE);
        });
        if (shouldUpdate) {
            this.dispatch(types_2.Action.UPDATE);
        }
        return this;
    };
    ModalMessage.prototype.dispatch = function (action) {
        switch (action) {
            case types_2.Action.OPEN:
                this.app.dispatch(openModal(this.payload));
                break;
            case types_2.Action.CLOSE:
                this.close();
                break;
            case types_2.Action.UPDATE:
                this.app.dispatch(update(this.payload));
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    type: action,
                }));
        }
        return this;
    };
    return ModalMessage;
}(Modal));
exports.ModalMessage = ModalMessage;
var ModalIframe = /** @class */ (function (_super) {
    __extends(ModalIframe, _super);
    function ModalIframe(app, options) {
        var _this = _super.call(this, app, exports.GROUP, exports.GROUP) || this;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ModalIframe.prototype, "payload", {
        get: function () {
            return __assign({}, this.options, { footer: this.footer, id: this.id });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModalIframe.prototype, "options", {
        get: function () {
            return {
                footer: this.footerOptions,
                path: this.path,
                size: this.size,
                title: this.title,
                url: this.url,
            };
        },
        enumerable: true,
        configurable: true
    });
    ModalIframe.prototype.set = function (options, shouldUpdate) {
        var _this = this;
        if (shouldUpdate === void 0) { shouldUpdate = true; }
        var mergedOptions = helper_1.getMergedProps(this.options, options);
        var title = mergedOptions.title, footer = mergedOptions.footer, path = mergedOptions.path, url = mergedOptions.url, size = mergedOptions.size;
        if (!this.validateOptions(mergedOptions)) {
            return this;
        }
        this.title = title;
        this.url = url;
        this.path = path;
        this.size = size;
        this.setFooterPrimaryButton(footer ? footer.buttons.primary : undefined, function () {
            _this.dispatch(types_2.Action.UPDATE);
        });
        this.setFooterSecondaryButtons(footer ? footer.buttons.secondary : undefined, function () {
            _this.dispatch(types_2.Action.UPDATE);
        });
        if (shouldUpdate) {
            this.dispatch(types_2.Action.UPDATE);
        }
        return this;
    };
    ModalIframe.prototype.dispatch = function (action) {
        switch (action) {
            case types_2.Action.OPEN:
                this.app.dispatch(openModal(this.payload));
                break;
            case types_2.Action.CLOSE:
                this.close();
                break;
            case types_2.Action.UPDATE:
                this.app.dispatch(update(this.payload));
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    type: action,
                }));
        }
        return this;
    };
    return ModalIframe;
}(Modal));
exports.ModalIframe = ModalIframe;
exports.create = function (app, options) {
    if (isIframeModal(options)) {
        return new ModalIframe(app, options);
    }
    return new ModalMessage(app, options);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FILE_URI_MATCH = /\/\/\//;
var INVALID_RELATIVE_URL = /[/\\][/\\]/;
var VALID_PROTOCOLS = ['https:', 'http:'];
var DUMMY_HOSTNAME = 'http://test.com';
function isSafe(redirectUrl, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.whitelist, whitelist = _c === void 0 ? [] : _c, _d = _b.subdomains, subdomains = _d === void 0 ? [] : _d, matchPath = _b.matchPath, requireAbsolute = _b.requireAbsolute, requireSSL = _b.requireSSL;
    if (FILE_URI_MATCH.test(redirectUrl)) {
        return false;
    }
    if (redirectUrl.startsWith('/')) {
        if (whitelist.length > 0 || subdomains.length > 0 || requireAbsolute || requireSSL) {
            return false;
        }
        if (matchPath) {
            // Creating a new URL expands the pathname in case of things like `/a/../b`
            return pathMatches(new URL(redirectUrl, DUMMY_HOSTNAME), redirectUrl, matchPath);
        }
        return !INVALID_RELATIVE_URL.test(redirectUrl);
    }
    var url;
    try {
        url = new URL(redirectUrl);
    }
    catch (error) {
        return false;
    }
    if (!VALID_PROTOCOLS.includes(url.protocol)) {
        return false;
    }
    if (requireSSL && url.protocol !== 'https:') {
        return false;
    }
    if (url.username || url.password) {
        return false;
    }
    if (matchPath && !pathMatches(url, redirectUrl, matchPath)) {
        return false;
    }
    if (!hostIsValid(url, whitelist, subdomains)) {
        return false;
    }
    return true;
}
exports.isSafe = isSafe;
function hostIsValid(url, whitelist, subdomains) {
    if (!subdomains.every(function (subdomain) { return subdomain.startsWith('.'); })) {
        throw new TypeError('Subdomains must begin with .');
    }
    var hostname = url.hostname;
    return ((whitelist.length === 0 && subdomains.length === 0) ||
        whitelist.includes(hostname) ||
        subdomains.some(function (subdomain) { return hostname.endsWith(subdomain); }));
}
function pathMatches(url, originalUrl, matcher) {
    var pathname = url.pathname;
    // Gets just the unresolve pathname, i.e., `http://foo.com/a/../b => /a/../b
    var originalPathname = originalUrl.replace(url.origin, '').split('?')[0];
    return typeof matcher === 'string'
        ? pathname === matcher && originalPathname === matcher
        : matcher.test(pathname) && matcher.test(originalPathname);
}
function makeSafe(url, fallback, options) {
    return isSafe(url, options) ? encodeURI(url) : fallback;
}
exports.makeSafe = makeSafe;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var validator_1 = __importDefault(__webpack_require__(44));
exports.validationError = validator_1.default;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var Error_1 = __webpack_require__(0);
var actions_1 = __webpack_require__(19);
var types_1 = __webpack_require__(7);
var actions_2 = __webpack_require__(20);
var types_2 = __webpack_require__(8);
function validationError(action) {
    if (helper_1.findMatchInEnum(types_2.ActionType, action.type)) {
        return actions_2.validationError(action);
    }
    if (helper_1.findMatchInEnum(types_1.ActionType, action.type)) {
        return actions_1.validationError(action);
    }
    return Error_1.invalidActionType(action);
}
exports.default = validationError;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(19));
__export(__webpack_require__(7));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(20));
__export(__webpack_require__(8));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module Print
 */
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Error_1 = __webpack_require__(0);
var types_2 = __webpack_require__(21);
function app() {
    return helper_1.actionWrapper({
        group: types_1.Group.Print,
        type: types_2.ActionType.APP,
    });
}
exports.app = app;
function validationError(action) {
    switch (action.type) {
        case types_2.ActionType.APP:
            // No validation since there should not be a payload
            return undefined;
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(49));
__export(__webpack_require__(22));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module ResourcePicker
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Error_1 = __webpack_require__(0);
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var types_2 = __webpack_require__(22);
exports.GROUP = types_1.Group.ResourcePicker;
function select(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.SELECT,
    });
}
exports.select = select;
function open(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.OPEN,
    });
}
exports.open = open;
function close(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.CLOSE,
    });
}
exports.close = close;
function update(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.UPDATE,
    });
}
exports.update = update;
function isValidResourceType(resourceType) {
    return helper_1.findMatchInEnum(types_2.ResourceType, resourceType);
}
function validationError(action) {
    var payload;
    switch (action.type) {
        case types_2.ActionType.UPDATE:
        case types_2.ActionType.OPEN:
            payload = action.payload;
            return payload !== undefined &&
                payload.id !== undefined &&
                typeof payload.id === 'string' &&
                isValidResourceType(payload.resourceType)
                ? undefined
                : Error_1.invalidPayload(action);
        case types_2.ActionType.SELECT:
            payload = action.payload;
            return payload !== undefined &&
                payload.id !== undefined &&
                typeof payload.id === 'string' &&
                Array.isArray(payload.selection)
                ? undefined
                : Error_1.invalidPayload(action);
        case types_2.ActionType.CLOSE:
            return undefined;
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
var ResourcePicker = /** @class */ (function (_super) {
    __extends(ResourcePicker, _super);
    function ResourcePicker(app, options, resourceType) {
        var _this = _super.call(this, app, exports.GROUP, exports.GROUP) || this;
        _this.selection = [];
        if (!isValidResourceType(resourceType)) {
            var errorAction = helper_1.actionWrapper({
                group: exports.GROUP,
                payload: __assign({ id: _this.id }, options, { resourceType: resourceType }),
            });
            Error_1.throwError(Error_1.ActionType.INVALID_OPTIONS, errorAction);
        }
        _this.resourceType = resourceType;
        _this.set(options, false);
        return _this;
    }
    Object.defineProperty(ResourcePicker.prototype, "payload", {
        get: function () {
            return __assign({}, this.options, { id: this.id, resourceType: this.resourceType });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourcePicker.prototype, "options", {
        get: function () {
            return {
                initialQuery: this.initialQuery,
                selectMultiple: this.selectMultiple,
                showHidden: this.showHidden,
                title: this.title,
            };
        },
        enumerable: true,
        configurable: true
    });
    ResourcePicker.prototype.set = function (options, shouldUpdate) {
        if (shouldUpdate === void 0) { shouldUpdate = true; }
        var mergedOptions = helper_1.getMergedProps(this.options, options);
        var initialQuery = mergedOptions.initialQuery, title = mergedOptions.title, showHidden = mergedOptions.showHidden, selectMultiple = mergedOptions.selectMultiple;
        this.initialQuery = initialQuery;
        this.title = title;
        this.showHidden = showHidden === false || true;
        this.selectMultiple = !!selectMultiple;
        if (shouldUpdate) {
            this.update();
        }
        return this;
    };
    ResourcePicker.prototype.dispatch = function (action, selection) {
        if (action === types_2.Action.OPEN) {
            this.open();
        }
        else if (action === types_2.Action.UPDATE) {
            this.update();
        }
        else if (action === types_2.Action.CLOSE) {
            this.close();
        }
        else if (action === types_2.Action.SELECT) {
            this.selection = selection;
            this.app.dispatch(select({ id: this.id, selection: this.selection }));
        }
        else {
            Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                group: this.group,
                type: action,
            }));
        }
        return this;
    };
    ResourcePicker.prototype.update = function () {
        this.app.dispatch(update(this.payload));
    };
    ResourcePicker.prototype.open = function () {
        this.app.dispatch(open(this.payload));
    };
    ResourcePicker.prototype.close = function () {
        this.app.dispatch(close({ id: this.id }));
    };
    return ResourcePicker;
}(helper_1.ActionSet));
exports.ResourcePicker = ResourcePicker;
exports.create = function (app, baseOptions) {
    var resourceType = baseOptions.resourceType, options = baseOptions.options;
    return new ResourcePicker(app, options, resourceType);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(51));
__export(__webpack_require__(23));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module TitleBar
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __webpack_require__(3);
var ButtonGroup_1 = __webpack_require__(4);
var buttonGroupHelper_1 = __webpack_require__(52);
var buttonHelper_1 = __webpack_require__(5);
var helper_1 = __webpack_require__(2);
var types_1 = __webpack_require__(1);
var Error_1 = __webpack_require__(0);
var types_2 = __webpack_require__(23);
exports.GROUP = types_1.Group.TitleBar;
var TITLEBAR_BUTTON_PROPS = {
    group: exports.GROUP,
    subgroups: ['Buttons'],
};
var BREADCRUMB_BUTTON_PROPS = {
    group: exports.GROUP,
    subgroups: ['Breadcrumbs'],
    type: types_1.ComponentType.Button,
};
function clickActionButton(id, payload) {
    var type = types_1.ComponentType.Button;
    var component = __assign({ id: id, type: type }, TITLEBAR_BUTTON_PROPS);
    return Button_1.clickButton(exports.GROUP, component, payload);
}
exports.clickActionButton = clickActionButton;
function clickBreadcrumb(id, payload) {
    var component = __assign({ id: id }, BREADCRUMB_BUTTON_PROPS);
    return Button_1.clickButton(exports.GROUP, component, payload);
}
exports.clickBreadcrumb = clickBreadcrumb;
function update(payload) {
    return helper_1.actionWrapper({
        payload: payload,
        group: exports.GROUP,
        type: types_2.ActionType.UPDATE,
    });
}
exports.update = update;
function isValidTitleBarPayload(payload) {
    if (!payload) {
        return false;
    }
    return ((payload.id === undefined || typeof payload.id === 'string') && isValidTitleBarProps(payload));
}
exports.isValidTitleBarPayload = isValidTitleBarPayload;
function isValidTitleBarProps(props) {
    return ((typeof props.title === 'string' || props.title === undefined) &&
        isValidTitleBarButtons(props.buttons) &&
        isValidTitleBarBreadcrumbs(props.breadcrumbs));
}
exports.isValidTitleBarProps = isValidTitleBarProps;
function isValidTitleBarButtons(buttons) {
    if (buttons === undefined) {
        return true;
    }
    if (typeof buttons !== 'object' || Array.isArray(buttons)) {
        return false;
    }
    var primary = buttons.primary;
    var secondary = buttons.secondary;
    if (primary && !Button_1.isValidButtonProps(primary)) {
        return false;
    }
    if (secondary !== undefined && !Array.isArray(secondary)) {
        return false;
    }
    if (Array.isArray(secondary)) {
        for (var _i = 0, secondary_1 = secondary; _i < secondary_1.length; _i++) {
            var button = secondary_1[_i];
            if (ButtonGroup_1.isGroupedButtonPayload(button) && ButtonGroup_1.isValidButtonGroupProps(button)) {
                continue;
            }
            else if (!ButtonGroup_1.isGroupedButtonPayload(button) && Button_1.isValidButtonProps(button)) {
                continue;
            }
            return false;
        }
    }
    return true;
}
exports.isValidTitleBarButtons = isValidTitleBarButtons;
function isValidTitleBarBreadcrumbs(button) {
    if (button === undefined || Button_1.isValidButtonProps(button)) {
        return true;
    }
    return false;
}
exports.isValidTitleBarBreadcrumbs = isValidTitleBarBreadcrumbs;
function validationError(action) {
    var payload;
    switch (action.type) {
        case types_2.ActionType.UPDATE:
            payload = action.payload;
            if (payload === undefined) {
                return Error_1.invalidPayload(action, Error_1.Message.MISSING_PAYLOAD);
            }
            if (typeof payload.id !== 'string') {
                return Error_1.invalidPayload(action, Error_1.Message.INVALID_PAYLOAD_ID);
            }
            return isValidTitleBarPayload(payload) ? undefined : Error_1.invalidPayload(action);
        case types_2.ButtonsActionType.BUTTON_CLICK:
        case types_2.ButtonsActionType.BREADCRUMBS_CLICK:
            return Button_1.validationError(__assign({}, action, { type: Button_1.ActionType.CLICK }));
        case types_2.ButtonsActionType.BUTTON_UPDATE:
        case types_2.ButtonsActionType.BREADCRUMBS_UPDATE:
            return Button_1.validationError(__assign({}, action, { type: Button_1.ActionType.UPDATE }));
        case types_2.ButtonsActionType.BUTTON_GROUP_UPDATE:
            return ButtonGroup_1.validationError(__assign({}, action, { type: ButtonGroup_1.ActionType.UPDATE }));
        default:
            return Error_1.invalidActionType(action);
    }
}
exports.validationError = validationError;
var TitleBar = /** @class */ (function (_super) {
    __extends(TitleBar, _super);
    function TitleBar(app, options) {
        var _this = _super.call(this, app, exports.GROUP, exports.GROUP) || this;
        // Trigger 'update' on creation
        _this.set(options);
        return _this;
    }
    Object.defineProperty(TitleBar.prototype, "buttons", {
        get: function () {
            if (!this.primary && !this.secondary) {
                return undefined;
            }
            return {
                primary: this.primary,
                secondary: this.secondary,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TitleBar.prototype, "buttonsOptions", {
        get: function () {
            if (!this.primaryOptions && !this.secondaryOptions) {
                return undefined;
            }
            return {
                primary: this.primaryOptions,
                secondary: this.secondaryOptions,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TitleBar.prototype, "options", {
        get: function () {
            return {
                breadcrumbs: this.breadcrumbsOption,
                buttons: this.buttonsOptions,
                title: this.title,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TitleBar.prototype, "payload", {
        get: function () {
            return __assign({}, this.options, { breadcrumbs: this.breadcrumb, buttons: this.buttons, id: this.id });
        },
        enumerable: true,
        configurable: true
    });
    TitleBar.prototype.set = function (options, shouldUpdate) {
        if (shouldUpdate === void 0) { shouldUpdate = true; }
        var mergedOptions = helper_1.getMergedProps(this.options, options);
        var title = mergedOptions.title, buttons = mergedOptions.buttons, breadcrumbs = mergedOptions.breadcrumbs;
        if (!this.validateOptions(mergedOptions)) {
            return this;
        }
        this.title = title;
        this.setBreadcrumbs(breadcrumbs);
        this.setPrimaryButton(buttons ? buttons.primary : undefined);
        this.setSecondaryButton(buttons ? buttons.secondary : undefined);
        if (shouldUpdate) {
            this.dispatch(types_2.Action.UPDATE);
        }
        return this;
    };
    TitleBar.prototype.dispatch = function (action) {
        switch (action) {
            case types_2.Action.UPDATE:
                this.app.dispatch(update(this.payload));
                break;
            default:
                Error_1.throwError(Error_1.ActionType.INVALID_ACTION_TYPE, helper_1.actionWrapper({
                    group: this.group,
                    type: action,
                }));
        }
        return this;
    };
    TitleBar.prototype.getButton = function (button, subgroups, updateCb) {
        if (button instanceof ButtonGroup_1.ButtonGroup) {
            return buttonGroupHelper_1.getGroupedButton(this, button, subgroups, updateCb);
        }
        return buttonHelper_1.getSingleButton(this, button, subgroups, updateCb);
    };
    TitleBar.prototype.updatePrimaryButton = function (newPayload) {
        if (!this.primary) {
            return;
        }
        if (helper_1.updateActionFromPayload(this.primary, Button_1.getSafeButtonProps(newPayload))) {
            this.dispatch(types_2.Action.UPDATE);
        }
    };
    TitleBar.prototype.updateSecondaryButtons = function (newPayload) {
        if (!this.secondary) {
            return;
        }
        var buttonToUpdate = this.secondary.find(function (action) { return action.id === newPayload.id; });
        if (!buttonToUpdate) {
            return;
        }
        var updated = false;
        if (ButtonGroup_1.isGroupedButtonPayload(newPayload)) {
            updated = helper_1.updateActionFromPayload(buttonToUpdate, ButtonGroup_1.getSafeButtonGroupProps(newPayload));
        }
        else {
            updated = helper_1.updateActionFromPayload(buttonToUpdate, Button_1.getSafeButtonProps(newPayload));
        }
        if (updated) {
            this.dispatch(types_2.Action.UPDATE);
        }
    };
    TitleBar.prototype.updateBreadcrumbButton = function (newPayload) {
        if (!this.breadcrumb) {
            return;
        }
        if (helper_1.updateActionFromPayload(this.breadcrumb, Button_1.getSafeButtonProps(newPayload))) {
            this.dispatch(types_2.Action.UPDATE);
        }
    };
    TitleBar.prototype.setPrimaryButton = function (newOptions) {
        this.primaryOptions = this.getChildButton(newOptions, this.primaryOptions);
        this.primary = this.primaryOptions
            ? this.getButton(this.primaryOptions, TITLEBAR_BUTTON_PROPS.subgroups, this.updatePrimaryButton)
            : undefined;
    };
    TitleBar.prototype.setSecondaryButton = function (newOptions) {
        var _this = this;
        var newButtons = newOptions || [];
        var currentButtons = this.secondaryOptions || [];
        this.secondaryOptions = this.getUpdatedChildActions(newButtons, currentButtons);
        this.secondary = this.secondaryOptions
            ? this.secondaryOptions.map(function (action) {
                return _this.getButton(action, TITLEBAR_BUTTON_PROPS.subgroups, _this.updateSecondaryButtons);
            })
            : undefined;
    };
    TitleBar.prototype.setBreadcrumbs = function (breadcrumb) {
        this.breadcrumbsOption = this.getChildButton(breadcrumb, this.breadcrumbsOption);
        this.breadcrumb = this.breadcrumbsOption
            ? this.getButton(this.breadcrumbsOption, BREADCRUMB_BUTTON_PROPS.subgroups, this.updateBreadcrumbButton)
            : undefined;
    };
    TitleBar.prototype.getChildButton = function (newAction, currentAction) {
        var newButtons = newAction ? [newAction] : [];
        var currentButtons = currentAction ? [currentAction] : [];
        var updatedButton = this.getUpdatedChildActions(newButtons, currentButtons);
        return updatedButton ? updatedButton[0] : undefined;
    };
    TitleBar.prototype.validateOptions = function (options) {
        var props = __assign({ id: this.id }, options);
        if (!isValidTitleBarProps(options)) {
            var errorAction = update(props);
            Error_1.throwError(Error_1.ActionType.INVALID_OPTIONS, errorAction);
            return false;
        }
        return true;
    };
    return TitleBar;
}(helper_1.ActionSetWithChildren));
exports.TitleBar = TitleBar;
function create(app, options) {
    return new TitleBar(app, options);
}
exports.create = create;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ButtonGroup_1 = __webpack_require__(4);
function getGroupedButton(action, button, subgroups, updateCb) {
    action.addChild(button, action.group, subgroups);
    var id = button.id, label = button.label, disabled = button.disabled, buttons = button.buttons;
    action.subscribeToChild(button, ButtonGroup_1.Action.UPDATE, updateCb);
    return { id: id, label: label, buttons: buttons, disabled: disabled };
}
exports.getGroupedButton = getGroupedButton;


/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module host
 */
Object.defineProperty(exports, "__esModule", { value: true });
var validator_1 = __webpack_require__(10);
var collection_1 = __webpack_require__(9);
/**
 * Create a MessageTransport from an IFrame.
 */
function fromFrame(frame, localOrigin) {
    var handlers = [];
    var parent = frame.ownerDocument.defaultView;
    parent.addEventListener('message', function (event) {
        if (!validator_1.isAppMessage(event)) {
            return;
        }
        for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
            var handler = handlers_1[_i];
            handler(event);
        }
    });
    return {
        localOrigin: localOrigin,
        hostFrame: parent,
        dispatch: function (message) {
            var contentWindow = frame.contentWindow;
            if (contentWindow) {
                contentWindow.postMessage(message, '*');
            }
        },
        subscribe: function (handler) {
            return collection_1.addAndRemoveFromCollection(handlers, handler);
        },
    };
}
exports.fromFrame = fromFrame;
/**
 * Create a MessageTransport from a parent window.
 */
function fromWindow(contentWindow, localOrigin) {
    var handlers = [];
    if (contentWindow !== window) {
        window.addEventListener('message', function (event) {
            if (event.source !== contentWindow ||
                !(validator_1.isAppBridgeAction(event.data.payload) || validator_1.isAppMessage(event))) {
                return;
            }
            for (var _i = 0, handlers_2 = handlers; _i < handlers_2.length; _i++) {
                var handler = handlers_2[_i];
                handler(event);
            }
        });
    }
    return {
        localOrigin: localOrigin,
        hostFrame: contentWindow,
        dispatch: function (message) {
            contentWindow.postMessage(message, '*');
        },
        subscribe: function (handler) {
            return collection_1.addAndRemoveFromCollection(handlers, handler);
        },
    };
}
exports.fromWindow = fromWindow;


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module client
 *
 * @todo Move `MessageTransport` into shared space.
 */
var helper_1 = __webpack_require__(2);
var validator_1 = __webpack_require__(10);
var Error_1 = __webpack_require__(0);
var Print_1 = __webpack_require__(25);
var MessageTransport_1 = __webpack_require__(54);
var collection_1 = __webpack_require__(9);
var env_1 = __webpack_require__(69);
var print_1 = __webpack_require__(70);
var redirect_1 = __webpack_require__(71);
function redirectHandler(hostFrame, config) {
    var apiKey = config.apiKey, shopOrigin = config.shopOrigin, _a = config.forceRedirect, forceRedirect = _a === void 0 ? !env_1.isDevelopmentClient : _a;
    var location = redirect_1.getLocation();
    if (forceRedirect && redirect_1.shouldRedirect(hostFrame) && apiKey && shopOrigin) {
        var url = "https://" + shopOrigin + "/admin/apps/" + apiKey + location.pathname + (location.search ||
            '');
        redirect_1.redirect(url);
    }
}
function appSetUp(app) {
    app.subscribe(Print_1.ActionType.APP, print_1.handleAppPrint);
}
function getUrlParams() {
    var location = redirect_1.getLocation();
    var hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');
    var params = {};
    return hashes.reduce(function (acc, hash) {
        var _a = hash.split('='), key = _a[0], val = _a[1];
        return __assign({}, acc, (_b = {}, _b[decodeURIComponent(key)] = decodeURIComponent(val), _b));
        var _b;
    }, params);
}
exports.getUrlParams = getUrlParams;
function getShopOrigin() {
    var params = getUrlParams();
    return params.shop;
}
exports.getShopOrigin = getShopOrigin;
exports.createClientApp = function (transport) {
    var getStateListeners = [];
    var listeners = [];
    var actionListeners = {};
    var invokeCallbacks = function (type, payload) {
        var hasCallback = false;
        if (actionListeners.hasOwnProperty(type)) {
            for (var _i = 0, _a = actionListeners[type]; _i < _a.length; _i++) {
                var listener = _a[_i];
                var id = listener.id, callback = listener.callback;
                var matchId = payload && payload.id === id;
                if (matchId || !id) {
                    callback(payload);
                    hasCallback = true;
                }
            }
        }
        if (hasCallback) {
            return;
        }
        // Throw an error if there are no subscriptions to this error
        var errorType = helper_1.findMatchInEnum(Error_1.ActionType, type);
        if (errorType) {
            Error_1.throwError(errorType, payload);
        }
    };
    var handler = function (event) {
        var action = event.data;
        switch (action.type) {
            case 'getState':
                var resolvers = getStateListeners.splice(0);
                resolvers.forEach(function (resolver) { return resolver(action.payload); });
                break;
            case 'dispatch':
                var payload_1 = action.payload;
                invokeCallbacks(payload_1.type, payload_1.payload);
                listeners.forEach(function (listener) { return listener.callback(payload_1); });
                break;
            default:
            // Silently swallow unknown actions
        }
    };
    transport.subscribe(handler);
    return function (config /*initialState*/) {
        redirectHandler(transport.hostFrame, config);
        var app = {
            localOrigin: transport.localOrigin,
            dispatch: function (action) {
                var validAction = validator_1.validatedAction(action, transport.localOrigin);
                var augmentedAction = {
                    payload: validAction,
                    source: config,
                    type: 'dispatch',
                };
                handler({ data: augmentedAction });
                transport.dispatch(augmentedAction);
                return validAction;
            },
            getState: function (query) {
                return new Promise(function (resolve) {
                    getStateListeners.push(resolve);
                    transport.dispatch({
                        payload: undefined,
                        source: config,
                        type: 'getState',
                    });
                }).then(function (state) {
                    if (query) {
                        return query.split('.').reduce(function (value, key) {
                            if (typeof state !== 'object' || Array.isArray(state)) {
                                return undefined;
                            }
                            value = state[key];
                            state = value;
                            return value;
                        }, undefined);
                    }
                    return state;
                });
            },
            subscribe: function () {
                if (arguments.length < 2) {
                    return collection_1.addAndRemoveFromCollection(listeners, { callback: arguments[0] });
                }
                var eventNameSpace = arguments[0];
                var callback = arguments[1];
                var id = arguments[2];
                var actionCallback = { callback: callback, id: id };
                if (!actionListeners.hasOwnProperty(eventNameSpace)) {
                    actionListeners[eventNameSpace] = [];
                }
                return collection_1.addAndRemoveFromCollection(actionListeners[eventNameSpace], actionCallback);
            },
            error: function (listener, id) {
                var _this = this;
                var unsubscribeCb = [];
                helper_1.forEachInEnum(Error_1.ActionType, function (eventNameSpace) {
                    // tslint:disable-next-line:no-invalid-this
                    unsubscribeCb.push(_this.subscribe(eventNameSpace, listener, id));
                });
                return function () {
                    unsubscribeCb.forEach(function (unsubscribe) { return unsubscribe(); });
                };
            },
        };
        appSetUp(app);
        return app;
    };
};
function createAppWrapper(frame, localOrigin) {
    var transport = MessageTransport_1.fromWindow(frame, localOrigin || window.location.origin);
    return exports.createClientApp(transport);
}
exports.createAppWrapper = createAppWrapper;
function default_1(config) {
    return createAppWrapper(window.top)(config);
}
exports.default = default_1;


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module client
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Client_1 = __importDefault(__webpack_require__(60));
exports.default = Client_1.default;
__export(__webpack_require__(60));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isServer = typeof window === 'undefined';
exports.isClient = !exports.isServer;
exports.isProduction = "production" === 'production';
exports.isDevelopment = !exports.isProduction;
exports.isDevelopmentClient = exports.isDevelopment && exports.isClient;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module client
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
function isMobileMiddlewareSupported() {
    return navigator.userAgent.indexOf('MobileMiddlewareSupported') >= 0;
}
function createHiddenInput() {
    if (!window.document || !window.document.body) {
        return;
    }
    var inputElement = window.document.createElement('input');
    inputElement.style.display = 'none';
    window.document.body.appendChild(inputElement);
    return inputElement;
}
function printWindow() {
    // @ts-ignore: Fixed in TypeScript 2.8.2
    window.print();
}
function handleMobileAppPrint() {
    var input = createHiddenInput();
    if (!input) {
        return;
    }
    input.select();
    printWindow();
    input.remove();
}
function handleAppPrint() {
    if (isMobileMiddlewareSupported()) {
        handleMobileAppPrint();
    }
    else {
        printWindow();
    }
}
exports.handleAppPrint = handleAppPrint;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module client
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
function shouldRedirect(frame) {
    return frame === window;
}
exports.shouldRedirect = shouldRedirect;
function redirect(url) {
    window.location.assign(url);
}
exports.redirect = redirect;
function getLocation() {
    return window.location;
}
exports.getLocation = getLocation;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js